/**
 * Created by zhengyf on 2018.1.12.
 */

/**
 * 引入了旧工程的
 * pop-select.js
 * base.js
 * GetHandlerClass.js
 */

;(function () {

    ProductFormCtrl.$inject = ['constantStore', 'request', '$timeout', 'fileUploaderService', '$q', '$scope', '$interval', 'DataRecoverService', 'editorInfo', 'UploaderService', 'event'];
    constantStore.$inject = ['COUNTRYS', 'PROVINCE_MAP', 'MEASURE_UNITS', 'MEASURE_UNITS_OBJ_ARRAY', 'TIME_UNITS', 'CURRENCY'];
    angular
        .module('DSSXAPP')
        .component('productFormComponent', {
            template:'<div class="product-post-component product-post-component-form"><div class="post-form-main"><div class="product-form" ng-hide="vm.c.showExportInfo"><div class="form-sections"><div class="ux-nav-bar clearfix ux-nav-bar-score-list"><ul><li ng-repeat="score in vm.c.scoreList track by $index" ng-class="{\'active\': score.selected}" ng-click="vm.f.gotoProductInfo($index)">{{score.title}}</li></ul></div><div class="ux-nav-bar clearfix"><div class="nav-category"><span class="category-title">当前类目：</span> <span class="category-value" ng-bind="vm.d.category.curName"></span> <span class="category-value" ng-bind="vm.d.directOrder===\'yes\'?\'| 直接下单品 |\':\'| 非直接下单品 |\'"></span> <span class="category-value"><label ng-if="vm.d.form.langMarket == \'EN\'">英语市场</label> <label ng-if="vm.d.form.langMarket == \'ES\'">西语市场</label> <label ng-if="vm.d.form.langMarket == \'JP\'">日语市场</label> <label ng-if="vm.d.form.langMarket == \'FR\'">法语市场</label> <label ng-if="vm.d.form.langMarket == \'PT\'">葡语市场</label> <label ng-if="vm.d.form.langMarket == \'RU\'">俄语市场</label> <label ng-if="vm.d.form.langMarket == \'DE\'">德语市场</label> <label ng-if="vm.d.form.langMarket == \'IT\'">意大利语市场</label> <label ng-if="vm.d.form.langMarket == \'AR\'">阿语市场</label> <label ng-if="vm.d.form.langMarket == \'TR\'">土耳其语市场</label> <label ng-if="vm.d.form.langMarket == \'KO\'">韩语市场</label> <label ng-if="vm.d.form.langMarket == \'VI\'">越南语市场</label></span> <a class="category-action" href="javascript:;" ng-click="vm.f.reSelect()">切换类目和产品类型</a></div></div><div class="basic-info-block section-item"><div class="info-title basic-info-title"><h3>基本信息</h3></div><div class="basic-info"><div class="ui-form-item next-row form-item-product-name"><label class="ui-form-label"><span class="label-name required">产品名称</span></label><div class="ui-form-control"><div class="input-wrap"><div class="input-area" ng-class="{\'err\': vm.d.errMsg.productName}"><input class="ui-input" maxlength="128" ng-model="vm.d.form.productName" ng-change="vm.f.countBasicInfoPer()" ng-blur="vm.f.checkFormData.checkProductName()"> <span>{{vm.d.form.productName.length}}/128</span></div><div class="input-tips"><span class="tips-trigger"><i class="iconfont icon-help"></i><div class="tips"><div><div>应包含品名、产品特征（属性）、行业标准、认证和型号等信息，避免罗列和堆砌。</div>范例："Full Suspension Mountain Bike"。<br><a href="http://service.alibaba.com/faq_detail.htm?id=10469630&amp;tracelog=ma_zsky_cpmc" target="_blank">如何设置产品名称？</a></div></div></span></div></div><p class="err-msg" ng-show="vm.d.errMsg.productName" ng-bind="vm.d.errMsg.productName"></p></div></div><div class="ui-form-item next-row form-item-keyword"><label class="ui-form-label"><span class="label-name required">产品关键词</span></label><div class="ui-form-control"><div class="input-wrap"><ul class="input-keyword-list"><li ng-repeat="key in vm.d.keywords track by $index"><div class="input-area" ng-class="{\'err\': key.err}"><input class="ui-input" ng-attr-placeholder="{{key.placeholder}}" ng-model="key.value" ng-change="vm.f.countBasicInfoPer()" ng-blur="vm.f.checkFormData.checkKeyword()"></div><i class="iconfont icon-delete" ng-click="vm.f.removeKeyword($index)" ng-show="vm.d.keywords.length > 1"></i></li></ul><div class="input-tips"><span class="tips-trigger"><i class="iconfont icon-help"></i><div class="tips"><div><div>请准确填写与产品名称相关或与之含义相近的词，以满足用户多样化的搜索需求。</div><div><span>特别提醒：</span> 关键词的设置须遵守 <a href="http://waimaoquan.alibaba.com/archive/cgs/integrity/rule.html#006" target="_blank">发布类网规</a>。 请注意该关键词不得涉及 <a href="http://waimaoquan.alibaba.com/archive/cgs/trade/safe/prohibitselling.html" target="_blank">阿里巴巴禁限售产品</a>； 如涉及 <a href="http://waimaoquan.alibaba.com/archive/cgs/integrity/ipr/iprs014.html" target="_blank">知识产权类产品</a>， 请确保信息发布前已提供了相关 <a href="http://waimaoquan.alibaba.com/archive/cgs/help/kh/aq_infringement_impower.html" target="_blank">授权证明</a>。 任何违规操作都可能导致您发布的产品被退回甚至影响到帐户使用权限。 <a href="http://service.alibaba.com/faq_detail.htm?id=10469854&tracelog=ma_zsky_cpgjc" target="_blank">如何设置产品关键词？</a></div></div></div></span></div></div><a class="add-more-keyword" href="javascript:;" ng-show="vm.d.keywords.length < 3" ng-click="vm.f.addMoreKeyword()">+ 添加更多关键词</a><div class="form-help">请至少填写一个关键词，所有关键词在搜索排序上权重相同，请不要重复填写。如您需要了解更多的品牌知识，请点此 <a class="not-allowed" href="javascript:;">查看</a></div><p class="err-msg" ng-repeat="key in vm.d.keywords track by $index" ng-show="key.err" ng-bind="key.err"></p><p class="err-msg" ng-show="vm.d.keywords[0].lengthError" ng-bind="vm.d.keywords[0].lengthError"></p></div></div><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name">产品分组</span></label><div class="ui-form-control"><div class="group-selector next-select medium next-col-6"><div ng-click="vm.f.ctrlGroupWindow($event)"><input placeholder="请选择分组" disabled ng-model="vm.d.form.group"> <i class="iconfont" ng-class="{\'icon-less\': vm.d.groupInfo.showList, \'icon-moreunfold\': !vm.d.groupInfo.showList}"></i></div><div class="sg-wrapper group-select-wrap" ng-show="vm.d.groupInfo.showList"><div class="header"><a ng-click="vm.f.ctrlAddGroupInput(\'open\')">添加分组</a></div><div class="body"><ul><li ng-repeat="group in vm.d.groupInfo.list track by $index"><a href="javascript:;" ng-bind="group.name" ng-click="vm.f.selectGroup(group)">未分组</a></li></ul></div></div></div><span class="tips-trigger"><i class="iconfont icon-help"></i><div class="tips"><div><p>产品组是您在网上公开展示产品的一个集合，您可以根据需要设置多个产品组，将同类产品放在一个产品组里面，方便买家查看。<br><br>每个产品一次只能在一个产品组中。<br></p><a href="//service.alibaba.com/faq_detail.htm?id=10471295&tracelog=ma_zsky_cpz" target="_blank">了解更多</a></div></div></span></div></div><div class="split"></div><div class="ui-form-sub-title">商品属性 <span>请填写准确、完整地产品属性，以便买家迅速了解产品特征。</span></div><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name">原产地</span></label><div class="ui-form-control"><div class="input-wrap input-wrap-flex-start"><select class="select" ng-model="vm.d.sourceAreaInfo.selected" ng-change="vm.f.showProvince()" ng-options="source.label for source in vm.d.sourceAreaInfo.list" ng-attr-value="{{source.value}}"></select><select class="select m-l8" ng-show="vm.d.provinceInfo.list.length" ng-model="vm.d.provinceInfo.selected" ng-options="province.label for province in vm.d.provinceInfo.list" ng-attr-value="{{province.value}}"></select></div></div></div><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name">品牌</span></label><div class="ui-form-control"><div class="input-wrap next-col-3"><div class="input-area" ng-class="{\'err\': vm.d.errMsg.brand}"><input class="ui-input" ng-model="vm.d.form.brand" ng-change="vm.f.countBasicInfoPer()" ng-blur="vm.f.checkFormData.checkBrand()"></div></div><p class="err-msg" ng-show="vm.d.errMsg.brand" ng-bind="vm.d.errMsg.brand"></p></div></div><div class="ui-form-item next-row form-item-model"><label class="ui-form-label"><span class="label-name">型号</span></label><div class="ui-form-control"><div class="input-wrap next-col-3"><div class="input-area" ng-class="{\'err\': vm.d.errMsg.model}"><input class="ui-input" ng-model="vm.d.form.model" ng-change="vm.f.countBasicInfoPer()" ng-blur="vm.f.checkFormData.checkModel()"></div></div><p class="err-msg" ng-show="vm.d.errMsg.model" ng-bind="vm.d.errMsg.model"></p></div></div><div class="ui-form-item next-row form-item-custom-attrs"><label class="ui-form-label"><span class="label-name">自定义属性</span></label><div class="custom-attrs ui-form-control"><table class="user-attr-table next-col-10"><tbody><tr class="custom-attr-item" ng-repeat="attr in vm.d.customAttrs track by $index"><td><span class="next-input-wrap next-col-fixed-8"><input class="ui-input" placeholder="属性名称 - 如: Color" ng-class="{\'err\': attr.nameError}" ng-model="attr.name" ng-blur="vm.f.checkFormData.checkCustomAttrs($index)"><p class="err-msg" ng-show="attr.nameError" ng-bind="attr.nameError"></p></span> <span class="next-input-wrap next-col-fixed-12"><input class="ui-input" placeholder="属性值 - 如: Red" ng-class="{\'err\': attr.valueError}" ng-model="attr.value" ng-blur="vm.f.checkFormData.checkCustomAttrs($index)"><p class="err-msg" ng-show="attr.valueError" ng-bind="attr.valueError"></p></span> <i class="iconfont icon-less" ng-class="{\'disabled\': $index === 0}" ng-show="vm.d.customAttrs.length > 1" ng-click="vm.f.moveCustomAttrs(\'up\', $index)"></i> <i class="iconfont icon-moreunfold" ng-class="{\'disabled\': $index === vm.d.customAttrs.length - 1}" ng-show="vm.d.customAttrs.length > 1" ng-click="vm.f.moveCustomAttrs(\'down\', $index)"></i> <i class="iconfont icon-delete" ng-show="vm.d.customAttrs.length > 1" ng-click="vm.f.moveCustomAttrs(\'delete\', $index)"></i></td></tr></tbody></table><p class="form-help">属性名和属性值必须同时填写，例：Color：Red</p><span class="click-add" ng-click="vm.f.moveCustomAttrs(\'add\')">+ 点击添加</span></div></div><div class="split"></div><div class="ui-form-sub-title">产品规格</div><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name">规格</span></label><div class="ui-form-control custom-attrs"><table class="user-attr-table next-col-10"><tbody><tr class="custom-attr-item" ng-repeat="spec in vm.d.productSpec track by $index"><td><span class="next-input-wrap next-col-fixed-8"><input type="text" class="ui-input" ng-model="spec.value"></span> <i class="iconfont icon-less" ng-class="{\'disabled\': $index === 0}" ng-click="vm.f.moveProductSpec(\'up\', $index)"></i> <i class="iconfont icon-moreunfold" ng-class="{\'disabled\': $index === vm.d.productSpec.length - 1}" ng-click="vm.f.moveProductSpec(\'down\', $index)"></i> <i class="iconfont icon-delete" ng-show="vm.d.productSpec.length > 1" ng-click="vm.f.moveProductSpec(\'delete\', $index)"></i></td></tr></tbody></table><span class="click-add" ng-click="vm.f.moveProductSpec(\'add\')">+ 添加</span></div></div></div></div><div class="product-detail-block section-item"><div class="info-title detail-info-title"><h3>商品描述</h3></div><div class="detail-info"><div class="ui-form-item next-row form-item-image"><label class="ui-form-label"><span class="label-name required">产品图片</span> <span class="tips-trigger"><i class="iconfont icon-help"></i><div class="tips"><div>图片制作规范。<a href="http://rule.alibaba.com/rule/detail/2087.htm" target="_blank">查看更多</a></div></div></span></label><div class="ui-form-control"><div class="image-uploader-wrap"><div class="btn-option-wrap"><label class="btn-upload"><input type="file" id="upload-file-btn" multiple accept=".jpeg, .jpg, .png" file-change="vm.f.uploader($event)"> <span>浏览</span></label> <a href="javascript:;" class="photo-bank-show-btn">从图片银行选取</a> <span>&nbsp;|&nbsp;</span> <a href="javascript:;" ng-click="vm.f.removeAllFile()">全部删除</a></div><div class="form-help"><span>单张不超过5M,支持jpeg，jpg，png格式;</span><br><span>建议图片大于640*640，主题鲜明、图片清晰、提升买家满意度；</span> <a target="_blank" href="//activity.alibaba.com/pc/588125f6.html?spm=a2747.post.0.0.e593376YSeIuU">查看图片质量规范</a></div><div class="file-list"><div class="ui-uploader clearfix"><div class="ui-uploader-content"><ul class="ui-uploader-list clearfix"><li class="ui-uploader-img-item ui-uploader-complete" ng-repeat="file in vm.d.files.list track by $index"><div class="image-main-image" ng-show="$index === 0"></div><div class="ui-uploader-img-wrap"><img ng-src="{{file.fileUrl}}"><progress ng-show="file.uploadStatus === \'uploading\' || file.uploadStatus === \'fail\'" ng-attr-max="{{file.progress.totalSize}}" ng-attr-value="{{file.progress.loadedSize}}"></progress></div><div class="ui-uploader-file-name util-ellipsis" ng-bind="file.fileName" ng-attr-title="{{file.fileName}}"></div><div class="ui-uploader-action"><span class="start" ng-show="file.uploadStatus === \'beUpload\'">待上传</span> <a href="javascript:;" class="status-action-remove" ng-show="file.uploadStatus === \'completed\'" ng-click="vm.f.removeFile($index)">删除</a> <a href="javascript:;" class="status-action-cancel" ng-class="{\'b\': file.uploadStatus === \'uploading\'}" ng-show="file.uploadStatus !== \'completed\'" ng-click="vm.f.cancelUploadingFile(file, $index)">取消</a></div></li></ul><div class="ui-uploader-info clearfix" ng-show="vm.d.files.progress.show"><span class="ui-uploader-hint">已上传: <span ng-bind="vm.d.files.uploadedNum"></span>/ 待上传:<span ng-bind="vm.d.files.beUploadNum"></span>, 剩余:<span ng-bind="vm.d.files.remainUploadNum"></span></span><progress ng-attr-max="{{vm.d.files.progress.totalSize}}" ng-attr-value="{{vm.d.files.progress.loadedSize}}"></progress><div class="ui-uploader-action"><a href="javascript:;" class="status-action-cancel" ng-click="vm.f.cancelAllUploadingFile()">全部取消</a></div></div></div><div class="uploader-error-msg" ng-show="vm.d.fileErrorMsg.length"><ul class="uploader-error-list"><li class="uploader-error-item" ng-repeat="file in vm.d.fileErrorMsg track by $index"><i class="ui2-icon-error" ng-show="file.showIcon"></i><div class="uploader-error-item-text" ng-class="{\'m-l0\': !file.showIcon}" ng-bind="file.info"></div></li></ul></div></div></div><p class="err-msg" ng-show="vm.d.files.showErrorMsg">请上传相关产品图片</p></div><div class="image-water-mark-wrap"><p><label><input type="checkbox" disabled> <span>给图片添加水印</span></label></p><p><label><input type="checkbox" checked disabled> <span>同时将上传的图片保存到图片银行</span></label></p></div></div></div><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name">产品视频</span></label><div class="ui-form-control"><div class="hint"><div><span>1、主图视频时长不超过45秒，大小不超过100M，展示位置在产品首图第一张</span> <a href="//activity.alibaba.com/pc/video_regulations.html" target="_blank">查看主图视频规范</a></div><div><span>2、详情视频时长不超过10分钟，大小不超过500M，展示位置在产品详情描述的上方</span> <a href="//waimaoquan.alibaba.com/bbs/read-htm-tid-3207869-1-fid-6.html" target="_blank">详情视频功能介绍</a></div><div><span>3、便于供应商上传主图视频和详情视频，视频空间由1G提升到3G。</span> <a href="https://activity.alibaba.com/pc/video_anli.html?spm=a262er.8235963.0.0.37751587lqojqu" target="_blank">产品视频案例红黑榜</a></div></div><div class="video-select-item"><div><span>选用主图视频</span><div class="uploader-video-border">暂无视频</div></div><div><span>选择在线定制模型</span><div class="uploader-video-border">暂无视频</div></div></div><div class="video-select-item"><div><span>选用详情视频</span><div class="uploader-video-border">暂无视频</div></div></div></div></div><div class="product-detail-describe-wrap"><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name">产品详情描述</span> <span class="tips-trigger"><i class="iconfont icon-help"></i><div class="tips"><div><div>1. 应包含规格参数、用途特征、质量标准、相关认证、服务等内容的详细描述；</div><div>2. 利用图片更直观的向买家展示产品信息，可以使用多角度图、细节图，包装、设计图等；</div><div>3. 将信息分段、标号，或使用表格，以方便买家的阅读；</div><div>4. 避免大段文字简单罗列，这会降低买家对产品的兴趣。</div><a href="http://service.alibaba.com/faq_detail.htm?id=10469566&tracelog=ma_zsky_xxms" target="_blank">了解更多</a></div></div></span></label><div class="ui-form-control"><span class="detail-tip">为了获得最佳的视觉效果，我们建议保持图片尺寸为750px（宽）*800px（高），表格的尺寸宽度为750px。（请注意，宽度超出750px 的部分将无法展示。）</span></div></div><div class="ui-form-item ui-form-details"><ul class="product-maya-switchbar clearfix"><li class="ui2-radio-customize"><label class="ui2-radio-customize-label"><input name="edit-detail" type="radio" ng-click="vm.f.toggleEditorMode(\'smart\')"> <span class="ui2-radio-customize-txt" ng-class="{\'selected\': vm.d.editMode === \'smart\'}">智能编辑</span></label></li><li class="ui2-radio-customize"><label class="ui2-radio-customize-label"><input name="edit-detail" type="radio" ng-click="vm.f.toggleEditorMode(\'normal\')"> <span class="ui2-radio-customize-txt" ng-class="{\'selected\': vm.d.editMode === \'normal\'}">普通编辑</span></label></li></ul></div><div ng-show="vm.d.editMode === \'smart\'"><smart-editor-component></smart-editor-component><div class="err-msg" ng-show="vm.d.errMsg.smartError" ng-bind="vm.d.errMsg.smartError"></div></div><div ng-show="vm.d.editMode === \'normal\'"><normal-editor-component content="vm.c.normalEdit" on-content-change="vm.onContentChange($event)" get-edit-content="vm.getNormalEditContent"></normal-editor-component></div></div></div></div><div class="trade-info-block section-item"><div class="info-title trade-info-title"><h3>交易信息</h3><span>完善交易信息，方便买家做出采购决定。</span></div><div class="trade-info"><div class="ui-form-item next-row" ng-hide="\'true\'"><label class="ui-form-label"><span class="label-name required">支持买家直接下单</span></label><div class="ui-form-control"><ul class="product-maya-switchbar clearfix m-l0"><li class="ui2-radio-customize price"><label class="radio-label"><input name="direct-order" type="radio" value="yes" ng-model="vm.d.directOrder"> <span>支持</span></label></li><li class="ui2-radio-customize price"><label class="radio-label"><input name="direct-order" type="radio" value="no" ng-model="vm.d.directOrder"> <span>不支持</span></label></li></ul><p class="form-help">支持买家直接发起信保订单，可快速提升该产品的订单转化，且获得更多曝光机会。</p></div></div><div ng-show="vm.d.directOrder === \'yes\'"><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name required">计量单位</span></label><div class="ui-form-control"><div class="group-selector w160 input-wrap next-col-6"><div ng-click="vm.f.showDropDownMenu(\'directOrderUnitsInfo\', $event)"><input disabled ng-model="vm.d.directOrderUnitsInfo.selected" ng-class="{\'err\': vm.d.errMsg.directOrder.unit}"> <i class="iconfont icon-moreunfold"></i></div><p class="err-msg" ng-show="vm.d.errMsg.directOrder.unit" ng-bind="vm.d.errMsg.directOrder.unit"></p><drop-down-select class="drop-down-select" list="vm.d.directOrderUnitsInfo.list" show-drop-down="vm.d.directOrderUnitsInfo.showList" drop-down-style="{width: \'240px\'}" on-select="vm.f.selectDropDownFinish($event, \'directOrderUnitsInfo\')"></drop-down-select></div></div></div><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name">销售方式</span></label><div class="ui-form-control"><ul class="product-maya-switchbar clearfix m-l0"><li class="ui2-radio-customize price"><label class="radio-label"><input name="sale-method" type="radio" value="byPiece" ng-model="vm.d.saleMethod"> <span>按件卖</span></label></li><li class="ui2-radio-customize price"><label class="radio-label"><input name="sale-method" type="radio" value="byBatch" ng-model="vm.d.saleMethod"> <span>按批卖</span></label></li></ul></div></div><div class="ui-form-item next-row form-item-sale-method" ng-show="vm.d.saleMethod === \'byBatch\'"><label class="ui-form-label"><span class="label-name required">1批等于</span></label><div class="ui-form-control"><div class="input-wrap next-col-3"><div class="input-area" ng-class="{\'err\': vm.d.errMsg.batchUnit}"><input class="ui-input" onkeyup="if(this.value.length===1){this.value=this.value.replace(/[^1-9]/g,\'\')}else{this.value=this.value.replace(/\\D/g,\'\')}" onafterpaste="if(this.value.length==1){this.value=this.value.replace(/[^1-9]/g,\'\')}else{this.value=this.value.replace(/\\D/g,\'\')}" ng-model="vm.d.directOrderInfo.batchUnit" ng-change="vm.f.countTradeInfoPer()" ng-blur="vm.f.checkFormData.checkBatchUnit()"> <span class="batch-unit">{{vm.d.directOrderUnitsInfo.selected}}</span></div></div><p class="err-msg" ng-show="vm.d.errMsg.batchUnit" ng-bind="vm.d.errMsg.batchUnit"></p></div></div></div><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name" ng-class="{\'required\': vm.d.directOrder === \'yes\'}">价格设置</span></label><div class="ui-form-control" ng-show="vm.d.directOrder === \'no\'"><label class="radio-label"><input type="radio" name="price-set" value="ladder" ng-model="vm.d.tradeMode"> <span>根据数量设置FOB阶梯价</span></label> <label class="radio-label"><input type="radio" name="price-set" value="single" ng-model="vm.d.tradeMode"> <span>单一FOB区间价格</span></label></div><div class="ui-form-control" ng-show="vm.d.directOrder === \'yes\'"><label class="radio-label"><input type="radio" checked> <span>根据数量设置价格</span></label></div></div><div ng-show="vm.d.directOrder === \'yes\'"><div class="ui-form-item next-row form-item-direct-order"><label class="ui-form-label"><span class="label-name">阶梯价</span></label><div class="ui-form-control"><div class="fob-price-range"><div class="ladder-price-setting"><div class="ladder-price-main-layout"><div class="next-table only-bottom-border"><div class="next-table-inner"><div class="next-table-header"><div class="next-table-header-inner"><table><tbody><tr><th class="next-table-header-node first"><div class="next-table-cell-wrapper"><label class="next-form-item-label required">最小起订量 <span class="help-text">(<span class="ladder-price-unit-text" title="计量单位">计量单位</span>)</span></label></div></th><th rowspan="1" class="next-table-header-node"><div class="next-table-cell-wrapper"><label class="next-form-item-label required">产品价格 <span class="help-text">(<span class="ladder-price-unit-text" title="计量单位">计量单位</span>)</span></label></div></th><th class="next-table-header-node last"><div class="next-table-cell-wrapper"></div></th></tr></tbody></table></div></div><div class="next-table-body"><table><tbody><tr class="next-table-row last" ng-repeat="ladder in vm.d.directOrderInfo.list track by $index"><td class="next-table-cell first"><div class="next-table-cell-wrapper"><div><span>≥</span> <span class="ladder-price-item-moq"><input maxlength="9" ng-model="ladder.order" ng-class="{\'err\': vm.d.errMsg.directOrder.order}" ng-change="vm.f.showDirectOrderPreview()" ng-blur="vm.f.checkFormData.checkDirectOrderOrder()"></span></div><div class="desc">{{(vm.d.directOrderInfo.preview[$index].order).substring(1)}} Piece/Pieces</div></div></td><td class="next-table-cell"><div class="next-table-cell-wrapper"><div><span>US $</span> <span class="ladder-price-item-price"><input maxlength="16" ng-model="ladder.price" ng-class="{\'err\': vm.d.errMsg.directOrder.price}" ng-change="vm.f.showDirectOrderPreview()" ng-blur="vm.f.checkFormData.checkDirectOrderPrice()"></span></div></div></td><td class="next-table-cell last"><div class="next-table-cell-wrapper" ng-show="vm.d.directOrderInfo.list.length > 1"><i class="iconfont icon-delete" ng-click="vm.f.ctrlDirectOrderInput(\'delete\', $index)"></i></div></td></tr></tbody></table></div></div></div><div class="ladder-price-add-more"><a href="javascript:;" ng-click="vm.f.ctrlDirectOrderInput(\'add\')">新增价格区间</a>（可设置不超过3个区间价格）</div></div><div class="ladder-price-preview-layout"><div class="ladder-price-preview-header"><span>预览</span> <span class="help-text"><span>（计量单位:</span> <span>计量单位</span> <span class="ladder-price-unit-text">）</span></span></div><div class="next-row" ng-show="vm.d.directOrderInfo.showPreview" ng-repeat="ladder in vm.d.directOrderInfo.preview track by $index"><div><div class="preview-left"><span ng-bind="ladder.order"></span></div><div class="preview-right"><span>US $</span> <span ng-bind="ladder.price" class="ladder-price"></span></div></div></div><div class="ladder-price-preview-noItem" ng-hide="vm.d.directOrderInfo.showPreview">可根据不同的销售数量设置不同价格</div></div></div><div><p class="err-msg" ng-show="vm.d.errMsg.directOrder.measure" ng-bind="vm.d.errMsg.directOrder.measure"></p><p class="err-msg" ng-show="vm.d.errMsg.directOrder.order" ng-bind="vm.d.errMsg.directOrder.order"></p><p class="err-msg" ng-show="vm.d.errMsg.directOrder.price" ng-bind="vm.d.errMsg.directOrder.price"></p></div></div></div></div><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name">可售数量</span></label><div class="ui-form-control"><div class="input-wrap next-col-3"><div class="input-area"><input type="text" class="ui-input" onkeyup="this.value=this.value.replace(/\\D/g,\'\')" onafterpaste="this.value=this.value.replace(/\\D/g,\'\')" ng-model="vm.d.directOrderInfo.vendibleNum"></div></div></div></div></div><div ng-show="vm.d.tradeMode === \'ladder\' && vm.d.directOrder === \'no\'"><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name" ng-class="{\'required\': vm.c.needCheckLadderMeasureUnit}">计量单位</span></label><div class="ui-form-control"><div class="group-selector w160 input-wrap next-col-6"><div ng-click="vm.f.showDropDownMenu(\'tradeLadderMeasureUnitsInfo\', $event)"><input disabled ng-model="vm.d.tradeLadderMeasureUnitsInfo.selected"> <i class="iconfont icon-moreunfold"></i></div><drop-down-select class="drop-down-select" list="vm.d.tradeLadderMeasureUnitsInfo.list" show-drop-down="vm.d.tradeLadderMeasureUnitsInfo.showList" drop-down-style="{width: \'240px\'}" on-select="vm.f.selectDropDownFinish($event, \'tradeLadderMeasureUnitsInfo\')"></drop-down-select></div></div></div><div class="ui-form-item next-row form-item-trade-ladder"><label class="ui-form-label"><span class="label-name">阶梯价</span></label><div class="ui-form-control"><div class="fob-price-range"><div class="ladder-price-setting"><div class="ladder-price-main-layout"><div class="next-table only-bottom-border"><div class="next-table-inner"><div class="next-table-header"><div class="next-table-header-inner"><table><tbody><tr><th class="next-table-header-node first"><div class="next-table-cell-wrapper"><label class="next-form-item-label">最小起订量 <span class="help-text">(<span class="ladder-price-unit-text" title="计量单位">计量单位</span>)</span></label></div></th><th rowspan="1" class="next-table-header-node"><div class="next-table-cell-wrapper"><label class="next-form-item-label">FOB价格 <span class="help-text">(<span class="ladder-price-unit-text" title="计量单位">计量单位</span>)</span></label></div></th><th class="next-table-header-node last"><div class="next-table-cell-wrapper"></div></th></tr></tbody></table></div></div><div class="next-table-body"><table><tbody><tr class="next-table-row last" ng-repeat="ladder in vm.d.tradeLadderInfo.list track by $index"><td class="next-table-cell first"><div class="next-table-cell-wrapper"><div><span>≥</span> <span class="ladder-price-item-moq"><input maxlength="9" ng-model="ladder.order" ng-class="{\'err\': vm.d.errMsg.tradeLadder.order}" ng-change="vm.f.showTradeLadderPreview()" ng-blur="vm.f.checkFormData.checkTradeLadderOrder()"></span></div></div></td><td class="next-table-cell"><div class="next-table-cell-wrapper"><div><span>US $</span> <span class="ladder-price-item-price"><input maxlength="16" ng-model="ladder.price" ng-class="{\'err\': vm.d.errMsg.tradeLadder.price}" ng-change="vm.f.showTradeLadderPreview()" ng-blur="vm.f.checkFormData.checkTradeLadderPrice()"></span></div></div></td><td class="next-table-cell last"><div class="next-table-cell-wrapper" ng-show="vm.d.tradeLadderInfo.list.length > 1"><i class="iconfont icon-delete" ng-click="vm.f.ctrlTradeLadderInput(\'delete\', $index)"></i></div></td></tr></tbody></table></div></div></div><div class="ladder-price-add-more"><a href="javascript:;" ng-click="vm.f.ctrlTradeLadderInput(\'add\')">新增价格区间</a>（可设置不超过4个区间价格）</div></div><div class="ladder-price-preview-layout"><div class="ladder-price-preview-header"><span>预览</span> <span class="help-text"><span>（计量单位:</span> <span>计量单位</span> <span class="ladder-price-unit-text">）</span></span></div><div class="next-row" ng-show="vm.d.tradeLadderInfo.showPreview" ng-repeat="ladder in vm.d.tradeLadderInfo.preview track by $index"><div><div class="preview-left"><span ng-bind="ladder.order"></span></div><div class="preview-right"><span>US $</span> <span ng-bind="ladder.price" class="ladder-price"></span></div></div></div><div class="ladder-price-preview-noItem" ng-hide="vm.d.tradeLadderInfo.showPreview">可根据不同的销售数量设置不同价格</div></div></div><div><p class="err-msg" ng-show="vm.d.errMsg.tradeLadder.measure" ng-bind="vm.d.errMsg.tradeLadder.measure"></p><p class="err-msg" ng-show="vm.d.errMsg.tradeLadder.order" ng-bind="vm.d.errMsg.tradeLadder.order"></p><p class="err-msg" ng-show="vm.d.errMsg.tradeLadder.price" ng-bind="vm.d.errMsg.tradeLadder.price"></p></div></div></div></div></div><div ng-show="vm.d.tradeMode === \'single\' && vm.d.directOrder === \'no\'"><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name" ng-class="{\'required\': vm.c.needCheckLadderMeasureUnit}">计量单位</span></label><div class="ui-form-control"><div class="group-selector w160 input-wrap next-col-6"><div ng-click="vm.f.showDropDownMenu(\'tradeSingleMeasureUnitsInfo\', $event)"><input disabled ng-model="vm.d.tradeSingleMeasureUnitsInfo.selected"> <i class="iconfont icon-moreunfold"></i></div><drop-down-select class="drop-down-select" list="vm.d.tradeSingleMeasureUnitsInfo.list" show-drop-down="vm.d.tradeSingleMeasureUnitsInfo.showList" drop-down-style="{width: \'160px\'}" on-select="vm.f.selectDropDownFinish($event, \'tradeSingleMeasureUnitsInfo\')"></drop-down-select></div></div></div><div class="ui-form-item next-row form-item-trade-single"><label class="ui-form-label"><span class="label-name">FOB价格</span></label><div class="ui-form-control clearfix fob-single-price"><div class="group-selector next-col w160"><div ng-click="vm.f.showDropDownMenu(\'currencyInfo\', $event)"><input disabled ng-model="vm.d.currencyInfo.selected"> <i class="iconfont icon-moreunfold"></i></div><drop-down-select class="drop-down-select" list="vm.d.currencyInfo.list" show-drop-down="vm.d.currencyInfo.showList" drop-down-style="{width: \'160px\'}" on-select="vm.f.selectDropDownFinish($event, \'currencyInfo\')"></drop-down-select></div><div class="next-col"><input ng-class="{\'err\': vm.d.tradeSingleInfo.priceMin.errMsg}" ng-model="vm.d.tradeSingleInfo.priceMin.value" ng-change="vm.f.countTradeInfoPer()" ng-blur="vm.f.checkFormData.checkTradeSinglePrice()"></div><div class="n-fixed-1">--</div><div class="next-col"><input ng-class="{\'err\': vm.d.tradeSingleInfo.priceMax.errMsg}" ng-model="vm.d.tradeSingleInfo.priceMax.value" ng-change="vm.f.countTradeInfoPer()" ng-blur="vm.f.checkFormData.checkTradeSinglePrice()"></div><p class="err-msg" ng-show="vm.d.tradeSingleInfo.currencyUnit.errMsg" ng-bind="vm.d.tradeSingleInfo.currencyUnit.errMsg"></p><p class="err-msg" ng-show="vm.d.tradeSingleInfo.measureUnit.errMsg" ng-bind="vm.d.tradeSingleInfo.measureUnit.errMsg"></p><p class="err-msg" ng-show="vm.d.tradeSingleInfo.priceMin.errMsg" ng-bind="vm.d.tradeSingleInfo.priceMin.errMsg"></p><p class="err-msg" ng-show="vm.d.tradeSingleInfo.priceMax.errMsg" ng-bind="vm.d.tradeSingleInfo.priceMax.errMsg"></p></div></div><div class="ui-form-item next-row form-item-order-min"><label class="ui-form-label"><span class="label-name">最小起订量</span></label><div class="ui-form-control"><input class="min-order" ng-class="{\'err\': vm.d.tradeSingleInfo.orderMin.errMsg}" ng-model="vm.d.tradeSingleInfo.orderMin.value" ng-change="vm.f.countTradeInfoPer()" ng-blur="vm.f.checkFormData.checkTradeSingleOrderMin()"> <span class="min-order-unit" ng-bind="vm.d.tradeSingleMeasureUnitsInfo.selected"></span> <a href="javascript:;" class="add-info" ng-class="{\'add\': vm.d.tradeSingleInfo.addInfo.show}" ng-click="vm.f.ctrlTradeSingleAddInfo(true)">添加补充信息</a><div class="add-info-wrap" ng-show="vm.d.tradeSingleInfo.addInfo.show"><input class="min-order" ng-class="{\'err\': vm.d.tradeSingleInfo.addInfo.errMsg}" ng-model="vm.d.tradeSingleInfo.addInfo.value" ng-blur="vm.f.checkFormData.checkTradeSingleAddInfo()"> <i class="iconfont icon-close" ng-click="vm.f.ctrlTradeSingleAddInfo(false)"></i></div><p class="err-msg" ng-show="vm.d.tradeSingleInfo.orderMin.errMsg" ng-bind="vm.d.tradeSingleInfo.orderMin.errMsg"></p><p class="err-msg" ng-show="vm.d.tradeSingleInfo.addInfo.errMsg" ng-bind="vm.d.tradeSingleInfo.addInfo.errMsg"></p></div></div></div><div class="ui-form-item next-row form-item-pay-method" ng-show="vm.d.directOrder === \'no\'"><label class="ui-form-label"><span class="label-name">支付方式</span></label><div class="ui-form-control payment-mode"><label><input type="checkbox" value="L/C" ng-model="vm.d.payMethod.lc.selected" ng-change="vm.f.countTradeInfoPer()"> <span>L/C</span></label> <label><input type="checkbox" value="D/A" ng-model="vm.d.payMethod.da.selected" ng-change="vm.f.countTradeInfoPer()"> <span>D/A</span></label> <label><input type="checkbox" value="D/P" ng-model="vm.d.payMethod.dp.selected" ng-change="vm.f.countTradeInfoPer()"> <span>D/P</span></label> <label><input type="checkbox" value="T/T" ng-model="vm.d.payMethod.tt.selected" ng-change="vm.f.countTradeInfoPer()"> <span>T/T</span></label> <label><input type="checkbox" value="Western Union" ng-model="vm.d.payMethod.wu.selected" ng-change="vm.f.countTradeInfoPer()"> <span>Western Union</span></label> <label><input type="checkbox" value="MoneyGram" ng-model="vm.d.payMethod.mg.selected" ng-change="vm.f.countTradeInfoPer()"> <span>MoneyGram</span></label> <label><input type="checkbox" value="other" ng-model="vm.d.payMethod.other.selected" ng-change="vm.f.clearPayMethodErrorMsg()"> <span>Other</span></label><div class="other-pay-method" ng-show="vm.d.payMethod.other.selected"><input class="ui-input" maxlength="64" ng-class="{\'err\': vm.d.errMsg.payMethod}" ng-model="vm.d.payMethod.other.value" ng-blur="vm.f.checkFormData.checkPayMethod()"></div><p class="err-msg" ng-show="vm.d.errMsg.payMethod" ng-bind="vm.d.errMsg.payMethod"></p></div></div><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name required">样品服务设置</span></label><div class="ui-form-control"><p class="form-help lh-28">支持在线拿样，有助承接买家需求并提升交易概率；设置样品后，您需要设置对应的运费模板；</p><ul class="product-maya-switchbar clearfix m-l0"><li class="ui2-radio-customize price"><label class="ui2-radio-customize-label"><input type="radio" value="1"> <span class="ui2-radio-customize-txt disable">支持（推荐）</span></label></li><li class="ui2-radio-customize price"><label class="ui2-radio-customize-label"><input type="radio" value="0"> <span class="ui2-radio-customize-txt selected">不支持</span></label></li></ul></div></div></div></div><div class="package-info-block section-item"><div class="info-title package-info-title"><h3>物流信息</h3></div><div class="package-info"><div class="ui-form-item next-row" ng-show="vm.d.directOrder === \'yes\'"><label class="ui-form-label"><span class="label-name required">每个商品长宽高(含包装)</span></label><div class="ui-form-control"><div class="input-wrap-mix w60"><div class="input-area"><input class="ui-input" maxlength="10" ng-model="vm.d.form.logisticsInfo.sizePerProduct.length.value" ng-change="vm.f.countPackageInfoPer()" ng-blur="vm.f.checkFormData.checkSizePerProduct()"></div><div class="text-area">CM X</div><div class="input-area"><input class="ui-input" maxlength="10" ng-model="vm.d.form.logisticsInfo.sizePerProduct.width.value" ng-change="vm.f.countPackageInfoPer()" ng-blur="vm.f.checkFormData.checkSizePerProduct()"></div><div class="text-area">CM X</div><div class="input-area"><input class="ui-input" maxlength="10" ng-model="vm.d.form.logisticsInfo.sizePerProduct.height.value" ng-change="vm.f.countPackageInfoPer()" ng-blur="vm.f.checkFormData.checkSizePerProduct()"></div><div class="text-area">CM</div><div class="unit-area">/ Piece/Pieces</div></div><p class="err-msg" ng-show="vm.d.errMsg.sizePerProduct" ng-bind="vm.d.errMsg.sizePerProduct"></p></div></div><div class="ui-form-item next-row" ng-show="vm.d.directOrder === \'yes\'"><label class="ui-form-label"><span class="label-name required">每件商品毛重</span></label><div class="ui-form-control"><div class="input-wrap-mix w180"><div class="input-area"><input class="ui-input" maxlength="13" ng-model="vm.d.form.logisticsInfo.grossWeightPerProduct" ng-change="vm.f.countPackageInfoPer()" ng-blur="vm.f.checkFormData.checkGrossWeightPerProduct()"></div><div class="unit-area">KG / Piece/Pieces</div></div><p class="err-msg" ng-show="vm.d.errMsg.grossWeightPerProduct" ng-bind="vm.d.errMsg.grossWeightPerProduct"></p></div></div><div class="ui-form-item next-row form-item-delivery-time"><label class="ui-form-label"><span class="label-name required">发货期</span></label><div class="ui-form-control"><div class="fob-price-range"><div class="ladder-price-setting"><div class="ladder-price-main-layout"><div class="next-table only-bottom-border"><div class="next-table-inner"><div class="next-table-header"><div class="next-table-header-inner"><table><tbody><tr><th class="next-table-header-node first"><div class="next-table-cell-wrapper"><label class="next-form-item-label">数量 <span class="help-text">(<span class="ladder-price-unit-text" title="计量单位">计量单位</span>)</span></label></div></th><th rowspan="1" class="next-table-header-node"><div class="next-table-cell-wrapper"><label class="next-form-item-label">天 <span class="help-text">(<span class="ladder-price-unit-text" title="计量单位">计量单位</span>)</span></label></div></th><th class="next-table-header-node last"><div class="next-table-cell-wrapper"></div></th></tr></tbody></table></div></div><div class="next-table-body"><table><tbody><tr class="next-table-row last" ng-repeat="delivery in vm.d.deliveryDateInfo.list track by $index"><td class="next-table-cell first"><div class="next-table-cell-wrapper"><div><span>≤</span> <span class="ladder-price-item-moq"><input maxlength="9" ng-model="delivery.num" ng-class="{\'err\': vm.d.errMsg.deliveryDateInfoIndex.num === $index || vm.d.errMsg.deliveryDateInfo}" ng-change="vm.f.showDeliveryInfoPreview()" ng-blur="vm.f.checkFormData.checkDeliveryInfo(\'num\')"></span></div></div></td><td class="next-table-cell"><div class="next-table-cell-wrapper"><div><span></span> <span class="ladder-price-item-price"><input maxlength="9" ng-model="delivery.day" ng-class="{\'err\': vm.d.errMsg.deliveryDateInfoIndex.day === $index}" ng-change="vm.f.showDeliveryInfoPreview()" ng-blur="vm.f.checkFormData.checkDeliveryInfo(\'day\')"></span></div></div></td><td class="next-table-cell last"><div class="next-table-cell-wrapper" ng-show="vm.d.deliveryDateInfo.list.length > 1"><i class="iconfont icon-delete" ng-click="vm.f.ctrlDeliveryInfoInput(\'delete\', $index)"></i></div></td></tr></tbody></table></div></div></div><div class="ladder-price-add-more"><a href="javascript:;" ng-click="vm.f.ctrlDeliveryInfoInput(\'add\')">增加数量区间</a>（可设置不超过3个区间）</div></div><div class="ladder-price-preview-layout"><div class="ladder-price-preview-header"><span>预览</span> <span class="help-text"><span>（计量单位:</span> <span>计量单位</span> <span class="ladder-price-unit-text">）</span></span></div><div class="next-row" ng-show="vm.d.deliveryDateInfo.showPreview" ng-repeat="delivery in vm.d.deliveryDateInfo.preview track by $index"><div><div class="preview-left"><span ng-bind="delivery.num"></span></div><div class="preview-right"><span ng-bind="delivery.day"></span></div></div></div><div class="ladder-price-preview-noItem" ng-hide="vm.d.deliveryDateInfo.showPreview">请根据不同的起订量设置不同发货周期（注意：发货期将作为订单约定进入信保保障流程，请务必根据实际情况设置合理发货时间，避免出现买家下单后未按期发货的违规行为）</div></div></div><div><p class="err-msg" ng-show="vm.d.errMsg.deliveryDateInfo" ng-bind="vm.d.errMsg.deliveryDateInfo"></p><p class="err-msg" ng-show="vm.d.errMsg.deliveryDateInfoIndex.num > -1">无效起订量：请输入1-999999999的整数</p><p class="err-msg" ng-show="vm.d.errMsg.deliveryDateInfoIndex.day > -1">无效时间：请输入1-999999999的整数</p></div></div></div></div><div class="ui-form-item next-row" ng-show="vm.d.directOrder === \'yes\'"><label class="ui-form-label"><span class="label-name required">运费模板</span></label><div class="ui-form-control"><div class="input-wrap"><select class="select" ng-model="vm.d.shipTemplatesInfo.selected" ng-change="vm.f.changeShipTemplate()" ng-attr-value="unit.value" ng-options="unit.label for unit in vm.d.shipTemplatesInfo.list"></select></div><p class="err-msg" ng-show="vm.d.errMsg.shipTemplate" ng-bind="vm.d.errMsg.shipTemplate"></p></div></div><div class="ui-form-item next-row" ng-show="vm.d.directOrder === \'yes\'"><label class="ui-form-label"><span class="label-name">发货运费参考</span></label><div class="ui-form-control"><div class="ship-template-tips"><div class="grey">以最小起订量为例，发往国家地区</div><select class="select"><option>United States</option></select><div class="result-box"><div><i class="iconfont icon-success"></i> <span>支持买家直接下单</span></div><div ng-show="vm.d.shipTemplatesInfo.selected.type === 0"><i class="iconfont icon-success"></i><span">有明确运费金额 | 部分核心国家没有明确的运费，将影响产品在对应国家的买家排序。</span"></div><div ng-show="vm.d.shipTemplatesInfo.selected.type !== 0"><i class="iconfont icon-wrong"></i> <span class="grey">有明确运费金额 | 部分核心国家没有明确的运费，将影响产品在对应国家的买家排序。</span></div><div><i class="iconfont icon-success"></i> <span>最小起订量交期小于等于15天</span></div></div><div class="footer">该商品不是 ready to ship 商品, 请按提示设置, 可在前台获取更多流量</div></div></div></div><div class="ui-form-item next-row" ng-show="vm.d.directOrder === \'no\'"><label class="ui-form-label"><span class="label-name required">物流模式</span></label><div class="ui-form-control"><label class="checkbox-label"><input type="checkbox" name="logistics-model" value="0" ng-model="vm.d.logisticsModel[0]" ng-change="vm.f.checkFormData.checkLogisticsModel()"> <span>快递</span></label> <label class="checkbox-label"><input type="checkbox" name="logistics-model" value="1" ng-model="vm.d.logisticsModel[1]" ng-change="vm.f.checkFormData.checkLogisticsModel()"> <span>海运</span></label> <label class="checkbox-label"><input type="checkbox" name="logistics-model" value="2" ng-model="vm.d.logisticsModel[2]" ng-change="vm.f.checkFormData.checkLogisticsModel()"> <span>陆运</span></label> <label class="checkbox-label"><input type="checkbox" name="logistics-model" value="3" ng-model="vm.d.logisticsModel[3]" ng-change="vm.f.checkFormData.checkLogisticsModel()"> <span>空运</span></label><p class="err-msg ng-binding" ng-show="vm.d.errMsg.logisticsModel" ng-bind="vm.d.errMsg.logisticsModel">每个商品长宽高不能为空</p></div></div><div class="ui-form-item next-row form-item-harbor" ng-show="vm.d.directOrder === \'no\'"><label class="ui-form-label"><span class="label-name">海运港口</span></label><div class="ui-form-control"><div class="input-wrap"><div class="input-area"><input class="ui-input" maxlength="128" ng-class="{\'err\': vm.d.errMsg.harbor}" ng-model="vm.d.form.harbor" ng-change="vm.f.countPackageInfoPer()" ng-blur="vm.f.checkFormData.checkHarbor()"> <span>{{vm.d.form.harbor.length}}/128</span></div></div><p class="err-msg" ng-show="vm.d.errMsg.harbor" ng-bind="vm.d.errMsg.harbor"></p></div></div><div class="ui-form-item next-row form-item-supplier-info" ng-show="vm.d.directOrder === \'no\'"><label class="ui-form-label"><span class="label-name">供货能力</span></label><div class="ui-form-control"><div class="input-wrap next-col-10"><div><div class="next-col-3 supply-ability"><input class="ui-input" maxlength="64" ng-class="{\'err\': vm.d.supplyInfo.errMsg}" ng-model="vm.d.supplyInfo.number" ng-change="vm.f.countPackageInfoPer()" ng-blur="vm.f.checkFormData.checkSupplyInfo()"></div><select class="supply-select" ng-model="vm.d.packageMeasureUnitsInfo.selected" ng-attr-value="unit.value" ng-change="vm.f.countPackageInfoPer()" ng-options="unit.label for unit in vm.d.packageMeasureUnitsInfo.list"></select><span>per</span><select class="supply-select" ng-model="vm.d.timeUnitsInfo.selected" ng-change="vm.f.countPackageInfoPer()" ng-attr-value="unit.value" ng-options="unit.label for unit in vm.d.timeUnitsInfo.list"></select></div></div><p class="ui-label-inline">请同时填写数值和单位</p><a href="javascript:;" class="add-info" ng-class="{\'add\': vm.d.supplyInfo.addInfo.show}" ng-click="vm.f.ctrlSupplyAddInfo(true)">添加补充信息</a><div class="add-info-wrap" ng-show="vm.d.supplyInfo.addInfo.show"><input class="ui-input w30" maxlength="64" ng-class="{\'err\': vm.d.supplyInfo.addInfo.errMsg}" ng-model="vm.d.supplyInfo.addInfo.text" ng-blur="vm.f.checkFormData.checkSupplyAddInfo()"> <i class="iconfont icon-close" ng-click="vm.f.ctrlSupplyAddInfo(false)"></i></div><p class="err-msg" ng-show="vm.d.supplyInfo.errMsg" ng-bind="vm.d.supplyInfo.errMsg"></p><p class="err-msg" ng-show="vm.d.supplyInfo.addInfo.errMsg" ng-bind="vm.d.supplyInfo.addInfo.errMsg"></p></div></div><div class="ui-form-item next-row form-item-packing"><label class="ui-form-label"><span class="label-name">包装方式</span></label><div class="ui-form-control"><div class="input-wrap"><div class="input-area" ng-class="{\'err\': vm.d.errMsg.packing}"><textarea class="next-input-multiple" cols="30" rows="3" ng-model="vm.d.form.packing" ng-change="vm.f.countPackageInfoPer()" ng-blur="vm.f.checkFormData.checkPacking()"></textarea> <span>{{vm.d.form.packing.length}}/512</span></div></div><p class="err-msg" ng-show="vm.d.errMsg.packing" ng-bind="vm.d.errMsg.packing"></p></div></div><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name">包装图片</span></label><div class="ui-form-control"><div class="image-uploader-wrap"><div class="btn-option-wrap"><a href="javascript:;" class="photo-bank-show-btn-package-image">从图片银行选取</a> <span>&nbsp;|&nbsp;</span> <a href="javascript:;" ng-click="vm.packageImage.removeAll()">全部删除</a></div><div class="form-help"><span>支持jpg 、png。文件大小：小于2MB</span></div><div class="package-image-upload-area"><div class="next-upload-list-item" ng-repeat="image in vm.packageImage.list track by $index"><div class="next-upload-list-item-info"><div class="next-upload-list-item-thumbnail"><div ng-style="{\'background-image\': \'url(\\\'\' + image.url + \'\\\')\'}"></div></div><span class="next-upload-list-item-name">{{image.name}}</span> <span class="next-upload-tool" ng-hide="vm.packageImage.uploading"><a target="_blank" ng-href="{{image.url + \'?dl=1\'}}"><i class="fa fa-download"></i></a> <span ng-click="vm.packageImage.remove($index)"><i class="fa fa-trash"></i></span></span><progress max="100" ng-attr-id="package-image-{{$index}}" ng-show="vm.packageImage.uploading && image.url === \'\'"></progress></div></div><div class="next-upload-select-picture-card" ng-show="vm.packageImage.list.length < 2 && !vm.packageImage.uploading"><div><label><input type="file" id="package-image-upload" multiple="false" accept=".jpeg, .jpg, .png" file-change="vm.packageImage.upload($event)"> <i class="iconfont icon-add"></i><div>从电脑选取</div></label></div></div></div></div></div></div></div></div><div class="special-service-block section-item"><div class="info-title special-service-title"><h3>特殊服务及其他</h3></div><div class="special-service"><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name required">定制服务</span></label><div class="ui-form-control"><ul class="product-maya-switchbar clearfix m-l0"><li class="ui2-radio-customize price"><label class="ui2-radio-customize-label"><input type="radio" value="1"> <span class="ui2-radio-customize-txt disable">支持定制（推荐）</span></label></li><li class="ui2-radio-customize price"><label class="ui2-radio-customize-label"><input type="radio" value="0"> <span class="ui2-radio-customize-txt selected">不支持</span></label></li></ul><p class="form-help">设置与表达定制能力，有助承接需要订制的买家需求与提升沟通效率</p></div></div><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name required">私域品服务</span></label><div class="ui-form-control"><ul class="product-maya-switchbar clearfix m-l0"><li class="ui2-radio-customize price"><label class="ui2-radio-customize-label"><input type="radio" value="1"> <span class="ui2-radio-customize-txt disable">私域产品</span></label></li><li class="ui2-radio-customize price"><label class="ui2-radio-customize-label"><input type="radio" value="0"> <span class="ui2-radio-customize-txt selected">不支持</span></label></li></ul></div></div><div class="ui-form-item next-row"><label class="ui-form-label"><span class="label-name required">生产可视化服务</span></label><div class="ui-form-control"><ul class="product-maya-switchbar clearfix m-l0"><li class="ui2-radio-customize price"><label class="ui2-radio-customize-label"><input type="radio" value="1"> <span class="ui2-radio-customize-txt disable">支持（推荐）</span></label></li><li class="ui2-radio-customize price"><label class="ui2-radio-customize-label"><input type="radio" value="0"> <span class="ui2-radio-customize-txt selected">不支持</span></label></li></ul><p class="form-help">具备对买家展示生产过程的能力，可帮助买家跟单</p></div></div></div></div><div class="post-panel-right small"><div><div class="post-panel-label">产品信息质量</div><div class="post-panel-score" ng-class="{\'disabled\': !vm.f.checkCoreForm(), \'high\': vm.f.checkAllFull() && vm.c.totalScore > 0}" ng-click="vm.f.getFormScore()"><div class="post-panel-score-text" ng-hide="vm.f.checkCoreForm()">填写核心信息后点击检测</div><div class="post-panel-score-text" ng-show="vm.f.checkCoreForm() && vm.c.totalScore === 0">点击检测</div><div class="post-panel-score-text" ng-show="vm.f.checkCoreForm() && vm.c.totalScore === -1">检测中……</div><div class="post-panel-score-text" ng-show="vm.f.checkCoreForm() && vm.c.totalScore > 0"><div class="post-panel-score-text-num">{{vm.c.totalScore | number: 1}} <sub>分</sub></div><div class="post-panel-score-text-tip">重新检测</div></div></div><div class="post-panel-tips" ng-hide="vm.c.totalScore !== 0">产品信息质量将直接影响搜索排序，<a>查看详情</a></div><div class="post-panel-tips" ng-show="vm.f.checkAllFull() && vm.c.totalScore > 0">当前产品信息质量优秀，利于搜索排序，建议持续优化！</div><div class="post-panel-tips" ng-show="!vm.f.checkAllFull() && vm.c.totalScore > 0">当前产品信息质量较差，将严重影响产品自身排序及买家搜索体验，请务必及时优化！</div><div class="post-panel-according" ng-show="vm.c.totalScore > 0"><div><div class="post-panel-according-title high"><span></span>产品类目</div></div><div ng-repeat="score in vm.c.scoreList track by $index" ng-hide="$index === vm.c.scoreList.length - 1"><div class="post-panel-according-title" ng-class="{\'high\': score.scoreCopy === 100}" ng-click="vm.f.showScoreDetail($index)"><span></span> {{score.title}} <i class="iconfont" ng-class="{\'icon-moreunfold\': score.showDetail, \'icon-less\': !score.showDetail}" ng-hide="score.scoreCopy === 100"></i></div><div class="post-panel-according-detail" ng-show="score.showDetail && score.scoreCopy !== 100" ng-click="vm.f.gotoProductInfo($index)"><div>{{score.title}}不完整</div></div></div></div><div class="post-panel-tips" ng-show="vm.c.totalScore > 0">产品信息质量诊断有问题？<a href="javascript:;">点此反馈</a></div></div></div><div class="form-error-tips small"><div><ul><li ng-show="vm.d.errMsg.productName"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-product-name\')">{{vm.d.errMsg.productName}}</a></li><li ng-repeat="key in vm.d.keywords track by $index" ng-show="key.err"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-keyword\')">{{key.err}}</a></li><li ng-show="vm.d.keywords[0].lengthError"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-keyword\')">{{vm.d.keywords[0].lengthError}}</a></li><li ng-show="vm.d.errMsg.model"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-model\')">{{vm.d.errMsg.model}}</a></li><li ng-show="vm.d.errMsg.brand"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-brand\')">{{vm.d.errMsg.brand}}</a></li><li ng-repeat="attr in vm.d.customAttrs track by $index" ng-show="attr.nameError || attr.valueError"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-custom-attrs\')" ng-show="attr.nameError">{{attr.nameError}}</a><br><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-custom-attrs\')" ng-show="attr.valueError">{{attr.valueError}}</a></li><li ng-show="vm.d.errMsg.batchUnit"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-sale-method\')">{{vm.d.errMsg.batchUnit}}</a></li><li ng-show="vm.d.errMsg.directOrder.measure"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-direct-order\')">{{vm.d.errMsg.directOrder.measure}}</a></li><li ng-show="vm.d.errMsg.directOrder.order"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-direct-order\')">{{vm.d.errMsg.directOrder.order}}</a></li><li ng-show="vm.d.errMsg.directOrder.price"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-direct-order\')">{{vm.d.errMsg.directOrder.price}}</a></li><li ng-show="vm.d.errMsg.tradeLadder.measure"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-ladder\')">{{vm.d.errMsg.tradeLadder.measure}}</a></li><li ng-show="vm.d.errMsg.tradeLadder.order"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-ladder\')">{{vm.d.errMsg.tradeLadder.order}}</a></li><li ng-show="vm.d.errMsg.tradeLadder.price"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-ladder\')">{{vm.d.errMsg.tradeLadder.price}}</a></li><li ng-show="vm.d.tradeSingleInfo.currencyUnit.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-single\')">{{vm.d.tradeSingleInfo.currencyUnit.errMsg}}</a></li><li ng-show="vm.d.tradeSingleInfo.measureUnit.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-single\')">{{vm.d.tradeSingleInfo.measureUnit.errMsg}}</a></li><li ng-show="vm.d.tradeSingleInfo.priceMin.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-single\')">{{vm.d.tradeSingleInfo.priceMin.errMsg}}</a></li><li ng-show="vm.d.tradeSingleInfo.priceMax.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-single\')">{{vm.d.tradeSingleInfo.priceMax.errMsg}}</a></li><li ng-show="vm.d.tradeSingleInfo.orderMin.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-order-min\')">{{vm.d.tradeSingleInfo.orderMin.errMsg}}</a></li><li ng-show="vm.d.tradeSingleInfo.addInfo.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-order-min\')">{{vm.d.tradeSingleInfo.addInfo.errMsg}}</a></li><li ng-show="vm.d.errMsg.payMethod"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-pay-method\')">{{vm.d.errMsg.payMethod}}</a></li><li ng-show="vm.d.errMsg.deliveryTime"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-delivery-time\')">{{vm.d.errMsg.deliveryTime}}</a></li><li ng-show="vm.d.errMsg.harbor"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-harbor\')">{{vm.d.errMsg.harbor}}</a></li><li ng-show="vm.d.supplyInfo.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-supplier-info\')">{{vm.d.supplyInfo.errMsg}}</a></li><li ng-show="vm.d.supplyInfo.addInfo.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-supplier-info\')">{{vm.d.supplyInfo.addInfo.errMsg}}</a></li><li ng-show="vm.d.errMsg.packing"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-packing\')">{{vm.d.errMsg.packing}}</a></li><li ng-show="vm.d.files.showErrorMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-image\')">请上传相关产品图片</a></li><li ng-show="vm.d.errMsg.smartError"><a ng-click="vm.f.gotoProductInfoDetail(\'product-detail-describe-wrap\')">{{vm.d.errMsg.smartError}}</a></li></ul></div></div><div class="form-footer"><div class="button-wrap"><button class="preview normal" ng-click="vm.f.previewInfo()">预览</button> <button class="save normal" ng-show="vm.d.form.status !== \'verified\'" ng-click="vm.f.saveProductInfo()">保存</button> <button class="submit primary" ng-class="{\'not-allow\': !vm.d.isCheckAgain}" ng-click="vm.f.submit()">提交</button> <button class="text" ng-click="vm.f.changeExportInfoView(true)" ng-hide="\'true\'">添加出口报关信息</button></div></div></div><div class="product-form-right"><div class="post-panel-right" ng-show="vm.f.showPostPanel()"><div><div class="post-panel-label">产品信息质量</div><div class="post-panel-score" ng-class="{\'disabled\': !vm.f.checkCoreForm(), \'high\': vm.f.checkAllFull() && vm.c.totalScore > 0}" ng-click="vm.f.getFormScore()"><div class="post-panel-score-text" ng-hide="vm.f.checkCoreForm()">填写核心信息后点击检测</div><div class="post-panel-score-text" ng-show="vm.f.checkCoreForm() && vm.c.totalScore === 0">点击检测</div><div class="post-panel-score-text" ng-show="vm.f.checkCoreForm() && vm.c.totalScore === -1">检测中……</div><div class="post-panel-score-text" ng-show="vm.f.checkCoreForm() && vm.c.totalScore > 0"><div class="post-panel-score-text-num">{{vm.c.totalScore | number: 1}} <sub>分</sub></div><div class="post-panel-score-text-tip">重新检测</div></div></div><div class="post-panel-tips" ng-hide="vm.c.totalScore !== 0">产品信息质量将直接影响搜索排序，<a>查看详情</a></div><div class="post-panel-tips" ng-show="vm.f.checkAllFull() && vm.c.totalScore > 0">当前产品信息质量优秀，利于搜索排序，建议持续优化！</div><div class="post-panel-tips" ng-show="!vm.f.checkAllFull() && vm.c.totalScore > 0">当前产品信息质量较差，将严重影响产品自身排序及买家搜索体验，请务必及时优化！</div><div class="post-panel-according" ng-show="vm.c.totalScore > 0"><div><div class="post-panel-according-title high"><span></span>产品类目</div></div><div ng-repeat="score in vm.c.scoreList track by $index" ng-hide="$index === vm.c.scoreList.length - 1"><div class="post-panel-according-title" ng-class="{\'high\': score.scoreCopy === 100}" ng-click="vm.f.showScoreDetail($index)"><span></span> {{score.title}} <i class="iconfont" ng-class="{\'icon-moreunfold\': score.showDetail, \'icon-less\': !score.showDetail}" ng-hide="score.scoreCopy === 100"></i></div><div class="post-panel-according-detail" ng-show="score.showDetail && score.scoreCopy !== 100" ng-click="vm.f.gotoProductInfo($index)"><div>{{score.title}}不完整</div></div></div></div><div class="post-panel-tips" ng-show="vm.c.totalScore > 0">产品信息质量诊断有问题？<a href="javascript:;">点此反馈</a></div></div></div><div class="form-error-tips"><div><ul><li ng-show="vm.d.errMsg.productName"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-product-name\')">{{vm.d.errMsg.productName}}</a></li><li ng-repeat="key in vm.d.keywords track by $index" ng-show="key.err"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-keyword\')">{{key.err}}</a></li><li ng-show="vm.d.keywords[0].lengthError"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-keyword\')">{{vm.d.keywords[0].lengthError}}</a></li><li ng-show="vm.d.errMsg.model"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-model\')">{{vm.d.errMsg.model}}</a></li><li ng-show="vm.d.errMsg.brand"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-brand\')">{{vm.d.errMsg.brand}}</a></li><li ng-repeat="attr in vm.d.customAttrs track by $index" ng-show="attr.nameError || attr.valueError"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-custom-attrs\')" ng-show="attr.nameError">{{attr.nameError}}</a><br><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-custom-attrs\')" ng-show="attr.valueError">{{attr.valueError}}</a></li><li ng-show="vm.d.errMsg.batchUnit"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-sale-method\')">{{vm.d.errMsg.batchUnit}}</a></li><li ng-show="vm.d.errMsg.directOrder.measure"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-direct-order\')">{{vm.d.errMsg.directOrder.measure}}</a></li><li ng-show="vm.d.errMsg.directOrder.order"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-direct-order\')">{{vm.d.errMsg.directOrder.order}}</a></li><li ng-show="vm.d.errMsg.directOrder.price"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-direct-order\')">{{vm.d.errMsg.directOrder.price}}</a></li><li ng-show="vm.d.errMsg.tradeLadder.measure"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-ladder\')">{{vm.d.errMsg.tradeLadder.measure}}</a></li><li ng-show="vm.d.errMsg.tradeLadder.order"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-ladder\')">{{vm.d.errMsg.tradeLadder.order}}</a></li><li ng-show="vm.d.errMsg.tradeLadder.price"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-ladder\')">{{vm.d.errMsg.tradeLadder.price}}</a></li><li ng-show="vm.d.tradeSingleInfo.currencyUnit.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-single\')">{{vm.d.tradeSingleInfo.currencyUnit.errMsg}}</a></li><li ng-show="vm.d.tradeSingleInfo.measureUnit.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-single\')">{{vm.d.tradeSingleInfo.measureUnit.errMsg}}</a></li><li ng-show="vm.d.tradeSingleInfo.priceMin.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-single\')">{{vm.d.tradeSingleInfo.priceMin.errMsg}}</a></li><li ng-show="vm.d.tradeSingleInfo.priceMax.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-trade-single\')">{{vm.d.tradeSingleInfo.priceMax.errMsg}}</a></li><li ng-show="vm.d.tradeSingleInfo.orderMin.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-order-min\')">{{vm.d.tradeSingleInfo.orderMin.errMsg}}</a></li><li ng-show="vm.d.tradeSingleInfo.addInfo.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-order-min\')">{{vm.d.tradeSingleInfo.addInfo.errMsg}}</a></li><li ng-show="vm.d.errMsg.payMethod"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-pay-method\')">{{vm.d.errMsg.payMethod}}</a></li><li ng-show="vm.d.errMsg.deliveryTime"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-delivery-time\')">{{vm.d.errMsg.deliveryTime}}</a></li><li ng-show="vm.d.errMsg.harbor"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-harbor\')">{{vm.d.errMsg.harbor}}</a></li><li ng-show="vm.d.supplyInfo.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-supplier-info\')">{{vm.d.supplyInfo.errMsg}}</a></li><li ng-show="vm.d.supplyInfo.addInfo.errMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-supplier-info\')">{{vm.d.supplyInfo.addInfo.errMsg}}</a></li><li ng-show="vm.d.errMsg.packing"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-packing\')">{{vm.d.errMsg.packing}}</a></li><li ng-show="vm.d.files.showErrorMsg"><a ng-click="vm.f.gotoProductInfoDetail(\'form-item-image\')">请上传相关产品图片</a></li><li ng-show="vm.d.errMsg.smartError"><a ng-click="vm.f.gotoProductInfoDetail(\'product-detail-describe-wrap\')">{{vm.d.errMsg.smartError}}</a></li></ul></div></div></div></div><div class="export-info" ng-show="vm.c.showExportInfo"><div class="export-info-card"><div class="icbu-card-title"><h2>出口信息 <span>通过一达通报关出口时才需操作： 添加和复用，如不需通过一达通出口报关无需填写出口信息，请直接提交产品</span></h2></div><div class="icbu-card-main"><div><div class="posting-export-tips">以下表单请用中文填写</div><div class="posting-ot-list"><p><button>+ 新增出口信息</button> <button>复用历史出口信息</button> <span>已添加 <strong>0</strong> 项/共可添加 20 项</span></p><div><div class="table-row"><div class="table-col-3">出口品名</div><div class="table-col-3">HScode</div><div class="table-col-3">退税率</div><div class="table-col-4">监管条件</div><div class="table-col-3">产品服务类型</div><div class="table-col-4">状态</div><div class="table-col-4">操作</div></div><div class="nodata"><button>尚无出口信息，请点击“新增出口信息”进行添加</button></div></div></div></div></div></div><div class="export-info-argument"><div><div class="export-info-argument-container"><div class="info-content"><div class="info-label">商品发布协议</div><label><input type="checkbox" checked disabled> <span><div>请再次检查并确认提交的信息真实、<a href="javascript:;">合法</a>和<a href="javascript:;">有效</a>。</div><div>信息发布上网或被退回后，您方可对此产品信息进行编辑。</div></span></label></div></div></div></div><div class="form-footer"><div class="button-wrap"><button class="save normal" ng-click="vm.f.changeExportInfoView(false)">上一步</button> <button class="submit primary" ng-class="{\'not-allow\': !vm.d.isCheckAgain}" ng-click="vm.f.submit()">提交</button></div></div></div></div><a href="javascript:;" class="goto-top" ng-show="vm.d.showGotoTopBtn && !vm.c.showExportInfo" ng-click="vm.f.gotoTop()"><em></em></a></div>',
            bindings: {
                category: '<', // 选择的类目
                directOrder: '<', // 产品类型
                langMarket: '<', // 语言市场
                form: '<', // 产品信息
                onReSelect: '&', // 重选类目
                onSubmit: '&', // 提交表单
                modifyFormTitle: '&', // 修改表单title
                getForm: '=' // 获得表单数据
            },
            controllerAs: 'vm',
            controller: ProductFormCtrl
        })
        .service('constantStore', constantStore);

    function constantStore(COUNTRYS, PROVINCE_MAP, MEASURE_UNITS, MEASURE_UNITS_OBJ_ARRAY, TIME_UNITS, CURRENCY) {

        var optionSelect = {value: '', label: '--请选择--'};
        var optionSelectProvince = {value: '', label: '--请选择--'};
        var optionUnit = {label: '计量单位', value: ''};
        var optionStr = '计量单位';
        var optionTime = {label: '时间单位', value: ''};
        var optionCurrency = '货币种类';

        this.COUNTRYS = [optionSelect].concat(COUNTRYS);
        this.PROVINCE_MAP = handleProvince(PROVINCE_MAP);
        this.MEASURE_UNITS = [optionStr].concat(MEASURE_UNITS);
        this.MEASURE_UNITS_OBJ_ARRAY = [optionUnit].concat(MEASURE_UNITS_OBJ_ARRAY);
        this.TIME_UNITS = [optionTime].concat(TIME_UNITS);
        this.CURRENCY = [optionCurrency].concat(CURRENCY);

        function handleProvince(provinces) {
            var result = {};
            for (var attr in provinces) {
                var list = provinces[attr];
                result[attr] = [optionSelectProvince].concat(list);
            }
            return result;
        }
    }


    function ProductFormCtrl(constantStore, request, $timeout, fileUploaderService, $q, $scope, $interval, DataRecoverService, editorInfo, UploaderService, event) {

        this.$onInit = onInit;
        this.$onChanges = bindingsOnChanges;

        var vm = this;
        var util = DSSX.util;
        var MAX_FILE_SIZE = 5 * 1024 * 1024;
        var commitProductPending = false; // 表单提交状态
        var normalEdit = {
            text: '',
            remainWordCount: 20000,
            remainImgCount: 15
        };
        var infoPercentOffsetTop = 248;
        var basicInfoToTop = 248;

        var PREVIEW_KEY = Date.parse(new Date()); // 产品预览的 key

        var basicInfoDom = $('.basic-info-block');
        var detailInfoDom = $('.product-detail-block');
        var tradeInfoDom = $('.trade-info-block ');
        var packageInfoDom = $('.package-info-block');
        var specialServiceDom = $('.special-service-block');

        var FILE_TYPE = ['jpeg', 'jpg', 'png'];

        // 表单校验
        var checkFormData = {
            findCN: function (str) { // 找到第一个连续的中文 返回数组，没找到返回 null
                var regExp = /[^a-zA-Z0-9\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F\s]+/;
                return str.match(regExp);
            },
            checkEn: function (type, data) {
                var d;
                if (data || data === '') {
                    d = data;
                } else {
                    d = vm.d.form[type];
                }

                var cn = this.findCN(d);
                if (cn) {
                    vm.d.errMsg[type] = validatorFn('onlyEnglish', {cn: cn[0]});
                    return false;
                }

                vm.d.errMsg[type] = '';
                return true;
            },
            checkEnAndLen: function (data, error) {
                var d = vm.d.form[data];
                var cn = this.findCN(d);

                if (cn) {
                    vm.d.errMsg[data] = validatorFn('onlyEnglish', {cn: cn[0]});
                    return false;
                }

                if (d.length > error.maxlength) {
                    vm.d.errMsg[data] = validatorFn('maxlength', error);
                    return false;
                }

                vm.d.errMsg[data] = '';
                return true;
            },
            checkProductName: function () {
                var productName = vm.d.form.productName;
                if (!productName) {
                    vm.d.errMsg.productName = validatorFn('required', {requiredName: '产品名称'});
                    return false;
                }

                var cn = this.findCN(productName);
                if (cn) {
                    vm.d.errMsg.productName = validatorFn('onlyEnglish', {cn: cn[0]});
                    return false;
                }

                vm.d.errMsg.productName = '';
                return true;
            },
            checkKeyword: function () {

                var keys = vm.d.keywords;
                var totalLength = 0;
                clearFormatError();

                var isEmpty = keys.every(function (item) {
                    return !item.value;
                });

                // 是否为空
                if (isEmpty) {
                    vm.d.keywords[0].err = validatorFn('atLeastOne', {atLeastOne: '关键词'});
                    return false;
                }

                // 显示格式错误并计算长度
                for (var i = 0; i < keys.length; i++) {
                    totalLength += keys[i].value.length;
                    var cn = this.findCN(keys[i].value);
                    if (cn) {
                        vm.d.keywords[i].err = validatorFn('onlyEnglish', {cn: cn[0]});
                    }
                }

                var isFormatErr = keys.some(function (item) {
                    return item.err;
                });

                if (totalLength > 255) {
                    vm.d.keywords[0].lengthError = '产品关键词与更多关键词长度之和不可超出255个字符';
                }

                if (isFormatErr || totalLength > 255) {
                    return false;
                }

                function clearFormatError() {
                    // 清除格式错误
                    for (var j = 0; j < keys.length; j++) {
                        vm.d.keywords[j].err = '';
                    }
                    vm.d.keywords[0].lengthError = '';
                }

                return true;
            },
            checkModel: function () {
                return this.checkEnAndLen('model', {filed: '型号', maxlength: 70});
            },
            checkBrand: function () {
                return this.checkEnAndLen('brand', {filed: '品牌', maxlength: 70});
            },
            checkCustomAttrs: function (index) {
                var customAttrs = vm.d.customAttrs;
                var d = customAttrs[index];
                var cn1 = this.findCN(d.name);
                var cn2 = this.findCN(d.value);
                var nameCheckResult = true; // 这个变量是为了检查 自定义属性重复 而定义使用的

                vm.d.customAttrs[index].nameError = '';
                vm.d.customAttrs[index].valueError = '';

                if (cn1) {
                    vm.d.customAttrs[index].nameError = validatorFn('onlyEnglish', {cn: cn1[0]});
                    nameCheckResult = false;
                }

                if (cn2) {
                    vm.d.customAttrs[index].valueError = validatorFn('onlyEnglish', {cn: cn2[0]});
                }

                if (d.value.length > 70) {
                    vm.d.customAttrs[index].valueError = validatorFn('maxlength', {filed: '属性值', maxlength: 70});
                }

                if (d.name.length > 40) {
                    vm.d.customAttrs[index].nameError = validatorFn('maxlength', {filed: '属性名', maxlength: 40});
                    nameCheckResult = false;
                }

                if (d.name.length && !d.value.length) {
                    vm.d.customAttrs[index].valueError = '属性值不能为空。';
                }

                if (d.value.length && !d.name.length) {
                    vm.d.customAttrs[index].nameError = '属性名不能为空。';
                }

                if (nameCheckResult) {
                    var repeatIndexList = [];
                    customAttrs.forEach(function (item, i) {
                        (d.name && item.name === d.name) && repeatIndexList.push(i);
                    });

                    if (repeatIndexList.length >= 2) {
                        vm.d.customAttrs[index].nameError = '请不要输入重复的属性名';
                    }
                }

                return !(vm.d.customAttrs[index].nameError || vm.d.customAttrs[index].valueError);
            },
            checkTradeSinglePrice: function () {
                var min = vm.d.tradeSingleInfo.priceMin.value;
                var max = vm.d.tradeSingleInfo.priceMax.value;
                var index1 = min.lastIndexOf('.');
                var index2 = max.lastIndexOf('.');
                vm.d.tradeSingleInfo.priceMin.errMsg = '';
                vm.d.tradeSingleInfo.priceMax.errMsg = '';

                if ((min && isNaN(min)) || (min && index1 !== -1 && min.slice(index1 + 1).length === 0)) {
                    vm.d.tradeSingleInfo.priceMin.errMsg = validatorFn('price', {filed: '最小价格'});
                }

                if ((max && isNaN(max)) || (max && index2 !== -1 && max.slice(index2 + 1).length === 0)) {
                    vm.d.tradeSingleInfo.priceMax.errMsg = validatorFn('price', {filed: '最大价格'});
                }

                if ((min && !isNaN(min) && (min < 0.0001 || min > 999999999.9999)) || (min && !isNaN(min) && (index1 !== -1) && (min.slice(index1 + 1).length > 4))) {
                    vm.d.tradeSingleInfo.priceMin.errMsg = validatorFn('precision', {filed: '最小价格'});
                }

                if ((max && !isNaN(max) && (max < 0.0001 || max > 999999999.9999)) || (max && !isNaN(max) && (index2 !== -1) && (max.slice(index2 + 1).length > 4))) {
                    vm.d.tradeSingleInfo.priceMax.errMsg = validatorFn('precision', {filed: '最大价格'});
                }

                if (vm.d.tradeSingleInfo.priceMax.errMsg || vm.d.tradeSingleInfo.priceMax.errMsg) {
                    return false;
                }

                if (min && max && +max <= +min) {
                    vm.d.tradeSingleInfo.priceMax.errMsg = '最大价格必须大于最小价格';
                }

                return !(vm.d.tradeSingleInfo.priceMax.errMsg || vm.d.tradeSingleInfo.priceMax.errMsg);
            },
            checkTradeSingleOrderMin: function () {
                var min = vm.d.tradeSingleInfo.orderMin.value;
                var index = min.lastIndexOf('.');
                vm.d.tradeSingleInfo.orderMin.errMsg = '';

                if ((min && isNaN(min)) || (min && index !== -1 && min.slice(index + 1).length === 0)) {
                    vm.d.tradeSingleInfo.orderMin.errMsg = validatorFn('price', {filed: '最小起订量'});
                }

                return !vm.d.tradeSingleInfo.orderMin.errMsg;
            },
            checkTradeSingleAddInfo: function () {
                var text = vm.d.tradeSingleInfo.addInfo.value;
                vm.d.tradeSingleInfo.addInfo.errMsg = '';

                var cn = this.findCN(text);
                if (cn) {
                    vm.d.tradeSingleInfo.addInfo.errMsg = validatorFn('onlyEnglish', {cn: cn[0]});
                }

                return !vm.d.tradeSingleInfo.addInfo.errMsg;
            },
            checkTradeLadderOrder: function () {
                var list = vm.d.tradeLadderInfo.list;
                vm.d.errMsg.tradeLadder.order = '';
                var integer = /[^0-9]/;

                var isEmpty = list.some(function (item, index, array) {
                    return !array[index].order && array[index].price;
                });

                if (isEmpty) {
                    vm.d.errMsg.tradeLadder.order = '最小起订量不能为空。';
                    return false;
                }

                var isFormatError = list.some(function (item) {
                    console.log(item)
                    return integer.test(item.order);
                });
                if (isFormatError) {
                    vm.d.errMsg.tradeLadder.order = validatorFn('pInteger');
                    return false;
                }

                var notMin2Max = list.some(function (item, index, array) {
                    if (index + 1 === array.length || !array[index].order || !array[index + 1].order) {
                        return false;
                    }
                    return +array[index].order - (+array[index + 1].order) >= 0;
                });

                if (notMin2Max) {
                    vm.d.errMsg.tradeLadder.order = validatorFn('orderMinAscending');
                    return false;
                }

                return true;
            },
            checkTradeLadderPrice: function () {
                var list = vm.d.tradeLadderInfo.list;
                vm.d.errMsg.tradeLadder.price = '';
                var reg = /^[0-9]+(\.[0-9]{1,4})?$/;

                var isEmpty = list.some(function (item, index, array) {
                    return array[index].order && !array[index].price;
                });

                if (isEmpty) {
                    vm.d.errMsg.tradeLadder.price = '价格不能为空。';
                    return false;
                }

                var isFormatError = list.some(function (item) {
                    if (!item.price) {
                        return false;
                    }

                    var result = !reg.test(item.price);
                    if (reg.test(item.price) && (item.price > 999999999.9999 || item.price < 0.0001)) {
                        result = true;
                    }

                    return result;
                });

                if (isFormatError) {
                    vm.d.errMsg.tradeLadder.price = validatorFn('precision', {filed: '价格'});
                    return false;
                }

                var notMax2Min = list.some(function (item, index, array) {
                    if (index + 1 === array.length || !array[index].price || !array[index + 1].price) {
                        return false;
                    }
                    return +array[index].price - (+array[index + 1].price) <= 0;
                });

                if (notMax2Min) {
                    vm.d.errMsg.tradeLadder.price = validatorFn('priceDescending');
                    return false;
                }

                return true;
            },
            checkDirectOrderUnit: function() {
                if (vm.d.directOrderUnitsInfo.selected === '计量单位') {
                    vm.d.errMsg.directOrder.unit = '计量单位不能为空';
                    return false;
                }
                vm.d.errMsg.directOrder.unit = '';
                return true;
            },
            checkDirectOrderOrder: function () {
                var list = vm.d.directOrderInfo.list;
                vm.d.errMsg.directOrder.order = '';
                var integer = /[^0-9]/;

                var isEmpty = list.some(function (item, index, array) {
                    return !array[index].order && array[index].price;
                });

                if (isEmpty) {
                    vm.d.errMsg.tradeLadder.order = '最小起订量不能为空。';
                    return false;
                }

                var isFormatError = list.some(function (item) {
                    return integer.test(item.order);
                });
                if (isFormatError) {
                    vm.d.errMsg.directOrder.order = validatorFn('pInteger');
                    return false;
                }

                var notMin2Max = list.some(function (item, index, array) {
                    if (index + 1 === array.length || !array[index].order || !array[index + 1].order) {
                        return false;
                    }
                    return +array[index].order - (+array[index + 1].order) >= 0;
                });

                if (notMin2Max) {
                    vm.d.errMsg.directOrder.order = validatorFn('orderMinAscending');
                    return false;
                }

                return true;
            },
            checkDirectOrderPrice: function () {
                var list = vm.d.directOrderInfo.list;
                vm.d.errMsg.directOrder.price = '';
                var reg = /^[0-9]+(\.[0-9]{1,4})?$/;

                var isEmpty = list.some(function (item, index, array) {
                    return array[index].order && !array[index].price;
                });

                if (isEmpty) {
                    vm.d.errMsg.directOrder.price = '价格不能为空。';
                    return false;
                }

                var isFormatError = list.some(function (item) {
                    if (!item.price) {
                        return false;
                    }

                    var result = !reg.test(item.price);
                    if (reg.test(item.price) && (item.price > 999999999.9999 || item.price < 0.0001)) {
                        result = true;
                    }

                    return result;
                });

                if (isFormatError) {
                    vm.d.errMsg.directOrder.price = validatorFn('precision', {filed: '价格'});
                    return false;
                }

                var notMax2Min = list.some(function (item, index, array) {
                    if (index + 1 === array.length || !array[index].price || !array[index + 1].price) {
                        return false;
                    }
                    return +array[index].price - (+array[index + 1].price) <= 0;
                });

                if (notMax2Min) {
                    vm.d.errMsg.directOrder.price = validatorFn('priceDescending');
                    return false;
                }

                return true;
            },
            checkBatchUnit: function () {
                if (vm.d.saleMethod !== 'byBatch') {
                    vm.d.errMsg.batchUnit = '';
                    return true;
                }

                var unit = vm.d.directOrderInfo.batchUnit;

                if (!unit) {
                    vm.d.errMsg.batchUnit = '必填项不能为空';
                    return false;
                }
                vm.d.errMsg.batchUnit = '';
                return true;
            },
            checkDeliveryInfo: function (arg_type) {
                var reg = /^[1-9]\d*$/;

                vm.d.errMsg.deliveryDateInfoIndex.num = -1;
                vm.d.errMsg.deliveryDateInfoIndex.day = -1;
                vm.d.errMsg.deliveryDateInfo = '';
                
                // 若为非必填项，取消以下注释
                /*
                if (vm.d.deliveryDateInfo.list.length === 1 && vm.d.deliveryDateInfo.list[0].num === '' && vm.d.deliveryDateInfo.list[0].day === '') {
                    return true;
                }
                */

                var previous = '';
                vm.d.deliveryDateInfo.list.forEach(function (value, index) {
                    if (vm.d.errMsg.deliveryDateInfoIndex.num !== -1 || vm.d.errMsg.deliveryDateInfoIndex.day !== -1 || vm.d.errMsg.deliveryDateInfo) {
                        return;
                    }

                    if (!reg.test(value.day)) {
                        vm.d.errMsg.deliveryDateInfoIndex.day = index;
                        return;
                    }

                    if (!reg.test(value.num)) {
                        vm.d.errMsg.deliveryDateInfoIndex.num = index;
                        return;
                    }

                    if (index && parseInt(value.num) <= parseInt(previous)) {
                        vm.d.errMsg.deliveryDateInfo = '发货期数量必须是由小到大';
                        return;
                    }

                    previous = value.num;
                });

                switch (arg_type) {
                    case 'num':
                        return vm.d.errMsg.deliveryDateInfoIndex.num === -1 && vm.d.errMsg.deliveryDateInfo === '';
                    case 'day':
                        return vm.d.errMsg.deliveryDateInfoIndex.day === -1;
                    default:
                        return false;
                }
            },
            checkPayMethod: function () {
                return this.checkEn('payMethod', vm.d.payMethod.other.value);
            },
            checkDeliveryTime: function () {
                return this.checkEn('deliveryTime');
            },
            checkHarbor: function () {
                return this.checkEn('harbor');
            },
            checkSupplyInfo: function () {
                var reg = /^[0-9]+(\.[0-9]+)?$/;
                var value = vm.d.supplyInfo.number;
                if (value && reg.test(value) === false) {
                    vm.d.supplyInfo.errMsg = validatorFn('price', {filed: '供货能力数量'});
                    return false;
                }
                vm.d.supplyInfo.errMsg = '';
                return true;
            },
            checkSupplyAddInfo: function () {
                var d = vm.d.supplyInfo.addInfo.text;
                var cn = this.findCN(d);
                if (cn) {
                    vm.d.supplyInfo.addInfo.errMsg = validatorFn('onlyEnglish', {cn: cn[0]});
                    return false;
                }

                vm.d.supplyInfo.addInfo.errMsg = '';
                return true;
            },
            checkPacking: function () {
                return this.checkEnAndLen('packing', {filed: '常规包装', maxlength: '512'});
            },
            checkMaxSample: function () {
                var maxSample = vm.d.specialService.maxSample;

                if (!maxSample) {
                    vm.d.specialService.maxSampleError = '单次最多索样数量不能为空。';
                    return false;
                }

                if (isNaN(maxSample) || (!isNaN(maxSample) && (+maxSample < 1 || +maxSample > 99999 || maxSample.indexOf('.') !== -1))) {
                    vm.d.specialService.maxSampleError = '请输入1-99999的整数';
                    return false;
                }

                vm.d.specialService.maxSampleError = '';
                return true;
            },
            checkSamplePrice: function () {
                var samplePrice = vm.d.specialService.samplePrice;

                if (!samplePrice) {
                    vm.d.specialService.samplePriceError = '样品价格不能为空。';
                    return false;
                }

                var priceArray = samplePrice.split('.');
                if (isNaN(samplePrice)
                    || (!isNaN(samplePrice)
                        && (+samplePrice < 0.01
                            || +samplePrice > 999999999.99
                            || (priceArray.length >= 2 && (!priceArray[1] || priceArray[1].length > 2))))) {
                    vm.d.specialService.samplePriceError = '样品价格请输入0.01-999999999.99之间的数值, 并精确到小数点后2位。';
                    return false;
                }

                vm.d.specialService.samplePriceError = '';
                return true;

            },
            checkSpecialServiceMeasureUnit: function () {
                if (vm.d.specialService.measureUnit.selected.label === '计量单位') {
                    vm.d.specialService.measureUnit.errMsg = '计量单位不能为空。';
                    return false;
                }

                vm.d.specialService.measureUnit.errMsg = '';
                return true;
            },
            checkGrossWeightPerProduct: function () {
                var grossWeightPerProduct = vm.d.form.logisticsInfo.grossWeightPerProduct;
                if (!grossWeightPerProduct) {
                    vm.d.errMsg.grossWeightPerProduct = validatorFn('required', {requiredName: '每件商品毛重'});
                    return false;
                }

                if(isNaN(grossWeightPerProduct)) {
                    vm.d.errMsg.grossWeightPerProduct = '请输入数字';
                    return false;
                }

                var num = parseFloat(grossWeightPerProduct);
                if(num > 999999999.999) {
                    vm.d.errMsg.grossWeightPerProduct = '每件商品毛重最大值999999999.999';
                    return false;
                }

                vm.d.errMsg.grossWeightPerProduct = '';
                return true;
            },
            checkLogisticsModel: function () {
                // 检测是否勾选物流模式
                var isErr = vm.d.logisticsModel.every(function(item) {
                    return !item;
                })

                if(isErr) {
                    vm.d.errMsg.logisticsModel = validatorFn('required', {requiredName: '物流模式'});
                    return false;
                }

                vm.d.errMsg.logisticsModel = '';
                return true;
            },
            checkSizePerProduct: function () {
                var length = vm.d.form.logisticsInfo.sizePerProduct.length.value;
                var width = vm.d.form.logisticsInfo.sizePerProduct.width.value;
                var height = vm.d.form.logisticsInfo.sizePerProduct.height.value;
                
                var checkLength = checkSizePerProductItem(length);
                var checkWidth = checkSizePerProductItem(width);
                var checkHeight = checkSizePerProductItem(height);

                if(!checkLength.success) {
                    vm.d.errMsg.sizePerProduct = checkLength.errMsg;
                    return false;
                }
                if(!checkWidth.success) {
                    vm.d.errMsg.sizePerProduct = checkWidth.errMsg;
                    return false;
                }
                if(!checkHeight.success) {
                    vm.d.errMsg.sizePerProduct = checkHeight.errMsg;
                    return false;
                }

                vm.d.errMsg.sizePerProduct = '';
                return true;

                function checkSizePerProductItem(item) {
                    var reg = /^[0-9]+(\.[0-9]{1,2})?$/;

                    if(!item) {
                        return {
                            success: false,
                            errMsg: validatorFn('required', {requiredName: '每个商品长宽高'}),
                        }
                    }

                    if(isNaN(item)) {
                        return {
                            success: false,
                            errMsg: '请输入数字',
                        }
                    }

                    if(parseFloat(item) <= 0) {
                        return {
                            success: false,
                            errMsg: '请输入大于0的数',
                        }
                    }
                    
                    if (!reg.test(item)) {
                        return {
                            success: false,
                            errMsg: '请精确到两位小数',
                        }
                    }

                    return {
                        success: true,
                    }
                }
            },
            checkShipTemplate: function () {
                if(vm.d.shipTemplatesInfo.list.length === 0) {
                    vm.d.errMsg.shipTemplate = '你尚未添加运费模板，请前往添加';
                    return false;
                }
                
                vm.d.errMsg.shipTemplate = '';
                return true;
            },
        };

        vm.c = {
            scoreList: [
                {
                    title: '基本信息',
                    class: 'basic-info-title',
                    score: '0%',
                    scoreNum: 0,
                    scoreCopy: 0,
                    showDetail: false,
                    selected: true
                },
                {
                    title: '商品描述',
                    class: 'detail-info-title',
                    score: '0%',
                    scoreNum: 0,
                    scoreCopy: 0,
                    showDetail: false,
                    selected: false
                },
                {
                    title: '交易信息',
                    class: 'trade-info-title',
                    score: '0%',
                    scoreNum: 0,
                    scoreCopy: 0,
                    showDetail: false,
                    selected: false
                },
                {
                    title: '物流信息',
                    class: 'package-info-title',
                    score: '0%',
                    scoreNum: 0,
                    scoreCopy: 0,
                    showDetail: false,
                    selected: false
                },
                {
                    title: '特殊服务及其他',
                    class: 'special-service-title',
                    score: '0%',
                    scoreNum: 0,
                    scoreCopy: 0,
                    showDetail: false,
                    selected: false
                }
            ],
            totalRateProgress: 0,
            totalScore: 0,
            needCheckLadderMeasureUnit: false, // FOB阶梯 是否需要校验计量单位
            needCheckSingleMeasureUnit: false, // FOB区间 是否需要校验计量单位
            needCheckCurrencyUnit: false, // FOB区间 是否需要校验货币单位
            isArrowRight: false,
            showExportInfo: false, // 填写出口信息
            normalEdit: ''
        };

        vm.d = {
            sketchId: '',
            category: {},
            sourceAreaInfo: { // 原产地
                list: constantStore.COUNTRYS,
                selected: constantStore.COUNTRYS[0]
            },
            provinceInfo: {
                list: [],
                selected: null
            },
            tradeLadderMeasureUnitsInfo: { // FOB阶梯价计量单位
                list: constantStore.MEASURE_UNITS,
                showList: false,
                selected: constantStore.MEASURE_UNITS[0]
            },
            tradeSingleMeasureUnitsInfo: { // 单一FOB区间价计量单位
                list: constantStore.MEASURE_UNITS,
                showList: false,
                selected: constantStore.MEASURE_UNITS[0]
            },
            directOrderUnitsInfo: { // 支持直接下单
                list: constantStore.MEASURE_UNITS,
                showList: false,
                selected: constantStore.MEASURE_UNITS[0]
            },
            packageMeasureUnitsInfo: { // 物流信息的计量单位
                list: constantStore.MEASURE_UNITS_OBJ_ARRAY,
                selected: constantStore.MEASURE_UNITS_OBJ_ARRAY[0]
            },
            timeUnitsInfo: { // 时间单位
                list: constantStore.TIME_UNITS,
                selected: constantStore.TIME_UNITS[0]
            },
            currencyInfo: { // 货币种类
                list: constantStore.CURRENCY,
                showList: false,
                selected: constantStore.CURRENCY[0]
            },
            shipTemplatesInfo: { // 运费模板
                list: [],
                selected: ''
            },
            keywords: [ // 添加的关键词
                {
                    value: '',
                    placeholder: '此处只能填写1个关键词，例：road bike',
                    err: '',
                    lengthError: ''
                },
                {
                    value: '',
                    placeholder: '',
                    err: '',
                    lengthError: ''
                },
                {
                    value: '',
                    placeholder: '',
                    err: '',
                    lengthError: ''
                }
            ],
            customAttrs: [ // 自定义属性
                {
                    name: '',
                    value: '',
                    nameError: '',
                    valueError: ''
                }
            ],
            productSpec: [
                {
                    value: ''
                }
            ],
            groupInfo: {
                list: [{name: '未分组'}],
                array: ['未分组'],
                showList: false,
                selected: ''
            },
            tradeSingleInfo: {
                priceMin: {
                    value: '',
                    errMsg: ''
                },
                priceMax: {
                    value: '',
                    errMsg: ''
                },
                orderMin: {
                    value: '',
                    errMsg: ''
                },
                addInfo: {
                    show: false,
                    value: '',
                    errMsg: ''
                },
                currencyUnit: {
                    errMsg: ''
                },
                measureUnit: {
                    errMsg: ''
                }
            },
            tradeLadderInfo: {
                list: [
                    {
                        order: '',
                        price: ''
                    }
                ],
                preview: [
                    {
                        order: '',
                        value: ''
                    }
                ],
                showPreview: false
            },
            directOrderInfo: {
                list: [
                    {
                        num: '',
                        day: ''
                    },
                    {
                        num: '',
                        day: ''
                    },
                    {
                        num: '',
                        day: ''
                    }
                ],
                preview: [
                    {
                        num: '',
                        day: ''
                    }
                ],
                batchUnit: '',
                vendibleNum: '',
                showPreview: false
            },
            deliveryDateInfo: {
                list: [
                    {
                        num: '',
                        day: ''
                    }
                ],
                preview: [
                    {
                        num: '',
                        day: ''
                    }
                ],
                showPreview: false
            },
            supplyInfo: {
                number: '',
                measureUnit: '',
                timeUnit: '',
                errMsg: '',
                addInfo: {
                    show: false,
                    text: '',
                    errMsg: ''
                }
            },
            payMethod: {
                lc: {
                    selected: false,
                    value: 'L/C'
                },
                da: {
                    selected: false,
                    value: 'D/A'
                },
                dp: {
                    selected: false,
                    value: 'D/P'
                },
                tt: {
                    selected: false,
                    value: 'T/T'
                },
                wu: {
                    selected: false,
                    value: 'Western Union'
                },
                mg: {
                    selected: false,
                    value: 'MoneyGram'
                },
                other: {
                    selected: false,
                    value: ''
                }
            },
            files: {
                // waitList: [],
                list: [],
                sentFiles: [],
                progress: {
                    totalSize: 0,
                    loadedSize: 0,
                    show: false
                },
                num: 0, // 为了给每个文件一个id,
                uploadedNum: 0,
                beUploadNum: 0,
                remainUploadNum: 0,
                showErrorMsg: false
            },
            editMode: 'smart', // 'normal' 普通编辑模式 'smart' 智能编辑
            fileErrorMsg: [], // 错误的文件
            showGotoTopBtn: false,

            isCheckAgain: true,
            isAddGroup: false,
            newGroup: '', // 新添加的分组
            directOrder: 'no',
            saleMethod: 'byPiece',
            tradeMode: 'ladder', // 交易模式 ladder fob阶梯价 single fob单一区间价
            specialService: {
                type: 'no', // orderSample requestSampleFree no
                maxSample: '',
                samplePrice: '',
                sampleUint: '',
                measureUnit: {
                    list: constantStore.MEASURE_UNITS_OBJ_ARRAY,
                    selected: constantStore.MEASURE_UNITS_OBJ_ARRAY[0],
                    errMsg: ''
                },
                maxSampleError: '',
                samplePriceError: ''
            },
            logisticsModel: [false, true, false, false], // 物流模式
            form: { // 表单信息
                category: '',
                productName: '',
                keyword: [],
                group: '',
                model: '',
                brand: '',
                sourceland: '',
                selfDefAttr: [],
                productSpec: [],
                deliveryTime: '',
                deliveryDate: [],
                harbor: '',
                packing: '',
                packingImgs: [],
                tradeInfo: {},
                langMarket: '',
                logisticsInfo: {
                    feightTmpl: {
                        id: '',
                    },
                    grossWeightPerProduct: '',
                    logisticsModel: '',
                    sizePerProduct: {
                        height: {
                            unit: 'CM',
                            value: '',
                        },
                        length: {
                            unit: 'CM',
                            value: '',
                        },
                        width: {
                            unit: 'CM',
                            value: '',
                        },
                    },
                    isRts: '',
                },
                score: '',
            },
            errMsg: {
                productName: '',
                model: '',
                brand: '',
                tradeLadder: {
                    order: '',
                    price: '',
                    measure: ''
                },
                directOrder: {
                    unit: '',
                    order: '',
                    price: '',
                    measure: ''
                },
                batchUnit: '',
                deliveryDateInfoIndex: {
                    num: -1,
                    day: -1
                },
                deliveryDateInfo: '',
                deliveryTime: '',
                harbor: '',
                packing: '',
                payMethod: '',
                smartError: '',
                sizePerProduct: '',
                grossWeightPerProduct: '',
                logisticsModel: '',
                shipTemplate: '',
            }
        };

        vm.f = {
            checkFormData: checkFormData,
            reSelect: reSelect,
            addMoreKeyword: addMoreKeyword,
            removeKeyword: removeKeyword,
            moveCustomAttrs: moveCustomAttrs,
            moveProductSpec: moveProductSpec,
            showDropDownMenu: showDropDownMenu,
            ctrlGroupWindow: ctrlGroupWindow,
            ctrlAddGroupInput: ctrlAddGroupInput,
            ctrlTradeSingleAddInfo: ctrlTradeSingleAddInfo,
            ctrlTradeLadderInput: ctrlTradeLadderInput,
            ctrlDirectOrderInput: ctrlDirectOrderInput,
            ctrlDeliveryInfoInput: ctrlDeliveryInfoInput,
            ctrlSupplyAddInfo: ctrlSupplyAddInfo,
            addNewGroup: addNewGroup,
            selectGroup: selectGroup,
            submitGroup: submitGroup,
            showTradeLadderPreview: showTradeLadderPreview,
            showDirectOrderPreview: showDirectOrderPreview,
            showDeliveryInfoPreview: showDeliveryInfoPreview,
            clearPayMethodErrorMsg: clearPayMethodErrorMsg,
            selectDropDownFinish: selectDropDownFinish,
            uploader: uploader,
            cancelUploadingFile: cancelUploadingFile,
            cancelAllUploadingFile: cancelAllUploadingFile,
            removeFile: removeFile,
            removeAllFile: removeAllFile,
            submit: submit,
            previewInfo: previewInfo,
            saveProductInfo: saveProductInfo,
            countBasicInfoPer: countBasicInfoPer,
            countTradeInfoPer: countTradeInfoPer,
            countPackageInfoPer: countPackageInfoPer,
            gotoProductInfo: gotoProductInfo,
            gotoProductInfoDetail: gotoProductInfoDetail,
            gotoTop: gotoTop,
            showProvince: showProvince,
            toggleEditorMode: toggleEditorMode,
            changeExportInfoView: changeExportInfoView,
            checkCoreForm: checkCoreForm,
            getFormScore: getFormScore,
            checkAllFull: checkAllFull,
            showScoreDetail: showScoreDetail,
            showPostPanel: showPostPanel,
            changeShipTemplate: changeShipTemplate
        };

        //
        vm.getNormalEditContent = null;
        vm.onContentChange = onContentChange;

        function onInit() {
            console.log('[product-form.js ProductFormCtrl init: ]');
            initVM();
            initBindingsEvent();
            loadGroups();
            initPhotoBank();
            initScrollEvent();
            initScopeWatch();
            initShipTemplates();
            $timeout(function () {
                onResize();
                vm.packageImage.init();
            })
        }

        function initVM() {
            vm.getForm = handleFormData;
        }

        function initBindingsEvent() {
            // 窗口拉伸事件
            $(window).on('resize', onResize);

            $(document).on('click', function () {
                ctrlGroupWindow('', 'close');
            });

            $('.group-select-wrap').on('click', function (e) {
                e.stopPropagation();
            });

            event.on('smart-editor-close', function () {
                vm.form = vm.form || {}
                vm.form.detailDesc = {
                    items: editorInfo.items,
                    preview: editorInfo.preview
                };
                countDetailInfoPer();
            });
        }

        function bindingsOnChanges(changes) {
            // 父组件（product-post）传值时，子组件赋值
            if (changes.category) {
                vm.d.category = vm.category || {};
                $('html, body').animate({'scrollTop': 0}, 0);
            }
            if (changes.directOrder) {
                vm.d.directOrder = vm.directOrder || 'no';
            }
            if (changes.langMarket) {
                vm.d.form.langMarket = vm.langMarket || 'EN';
            }

            if (changes.form) {

                if (!vm.form) {
                    return;
                }

                vm.modifyFormTitle();
                vm.d.form = vm.form; //
                handleEditForm(vm.form);
                countBasicInfoPer();
                countDetailInfoPer();
                countTradeInfoPer();
                countPackageInfoPer();
            }

            if (changes.sketchId) {
                vm.d.sketchId = vm.sketchId || '';
            }

        }

        // 切换类目和产品类型，向父组件（product-post）传值
        function reSelect() {
            vm.onReSelect({
                $event: {
                    path: vm.d.category,
                    directOrder: vm.d.directOrder,
                    langMarket: vm.d.form.langMarket
                }
            });
        }

        function handleEditForm(form) {
            if (!form) {
                return;
            }

            // 类目
            vm.d.category = {
                curName: form.category || '',
                enName: form.category || ''
            };

            vm.d.groupInfo.selected = form.group; // 保存选中的分组

            // 产品关键词
            vm.d.keywords = [];
            form.keyword = form.keyword || [];
            for (var i = 0; i < form.keyword.length; i++) {
                var key = {
                    value: form.keyword[i],
                    placeholder: '',
                    err: '',
                    lengthError: ''
                };

                if (i === 0) {
                    key.placeholder = '此处只能填写1个关键词，例：road bike';
                }

                vm.d.keywords.push(key);
            }

            if (vm.d.keywords.length === 2) {
                vm.d.keywords.push({
                    value: '',
                    placeholder: '',
                    err: '',
                    lengthError: ''
                });
            }

            if (!vm.d.keywords.length) {
                vm.d.keywords.push({
                    value: '',
                    placeholder: '此处只能填写1个关键词，例：road bike',
                    err: '',
                    lengthError: ''
                });
            }

            form.keyword = [];

            // 原产地
            form.sourceland = form.sourceland || {};

            for (var i2 = 0; i2 < vm.d.sourceAreaInfo.list.length; i2++) {
                if (vm.d.sourceAreaInfo.list[i2].value === form.sourceland.countryAbbr) {
                    vm.d.sourceAreaInfo.selected = vm.d.sourceAreaInfo.list[i2];
                    break;
                }
            }

            vm.d.provinceInfo.list = constantStore.PROVINCE_MAP[vm.d.sourceAreaInfo.selected.value];
            var province = form.sourceland.province;

            if (vm.d.provinceInfo.list && vm.d.provinceInfo.list.length) {
                if (province) {
                    for (var ii = 0; ii < vm.d.provinceInfo.list.length; ii++) {
                        if (province.indexOf(vm.d.provinceInfo.list[ii].label) !== -1) {
                            vm.d.provinceInfo.selected = vm.d.provinceInfo.list[ii];
                            break;
                        }
                    }
                } else {
                    vm.d.provinceInfo.selected = vm.d.provinceInfo.list[0];
                }
            }

            // 自定义属性
            vm.d.customAttrs = [];
            form.selfDefAttr = form.selfDefAttr || [];

            if (!form.selfDefAttr.length) {
                vm.d.customAttrs.push({
                    name: '',
                    value: '',
                    nameError: '',
                    valueError: ''
                });
            }

            for (var i3 = 0; i3 < form.selfDefAttr.length; i3++) {
                var selfAttr = {
                    name: form.selfDefAttr[i3].name,
                    value: form.selfDefAttr[i3].value,
                    nameError: '',
                    valueError: ''
                };
                vm.d.customAttrs.push(selfAttr);
            }
            form.selfDefAttr = [];

            Array.isArray(form.productSpec) && form.productSpec.length && (vm.d.productSpec = form.productSpec.map(function (element) {
                return {
                    value: element
                }
            }));
            form.productSpec = [];

            // 产品图片
            vm.d.files.list = [];
            vm.d.files.sentFiles = [];
            form.imgs = form.imgs || [];
            for (var i4 = 0; i4 < form.imgs.length; i4++) {
                var img = {
                    id: 'prod-file-' + vm.d.files.num, // 独一无二的id
                    fileUrl: form.imgs[i4].url,
                    fileName: form.imgs[i4].name,
                    size: 100,
                    uploadStatus: 'completed', // beUpload 准备上传  uploading 上传中 completed 上传完成 fail 上传失败
                    progress: {
                        totalSize: 100,
                        loadedSize: 100
                    }
                };
                vm.d.files.list.push(img);
                vm.d.files.sentFiles = form.imgs;
            }

            //
            if (form.detailDesc && !isEmptyObject(form.detailDesc)) {
                // 智能编辑
                vm.d.editMode = 'smart';
                editorInfo.init(form.detailDesc.preview, form.detailDesc.items);
                $('.maya-switchbarmin .non-content').hide();
                $('.maya-switchbarmin .has-content').show();

            } else {
                // 普通编辑
                vm.d.editMode = 'normal';
                form.normalEdit = form.normalEdit || '';
                vm.form.normalEdit = form.normalEdit;
                vm.c.normalEdit = form.normalEdit;
            }

            var tradeInfo = form.tradeInfo || {};
            if (form.directlyOrder === 1) {
                vm.d.directOrder = 'yes';
                vm.d.saleMethod = tradeInfo.saleMethod;
                vm.d.directOrderInfo.batchUnit = tradeInfo.batchUnit;
                vm.d.directOrderInfo.vendibleNum = tradeInfo.vendibleNum + '';
                vm.d.directOrderInfo.list = [];
                vm.d.directOrderInfo.preview = [];

                if (isEmptyObject(tradeInfo.quantityPrice)) {
                    vm.d.directOrderInfo.list.push({
                        order: '',
                        price: ''
                    });
                }

                vm.d.directOrderUnitsInfo.list.forEach(function (value) {
                    tradeInfo.measureUnit === value && (vm.d.directOrderUnitsInfo.selected = value);
                });

                for (var directOrderAttr in tradeInfo.quantityPrice) {
                    if (!tradeInfo.quantityPrice.hasOwnProperty(directOrderAttr)) {
                        return;
                    }

                    vm.d.directOrderInfo.list.push({
                        order: directOrderAttr,
                        price: tradeInfo.quantityPrice[directOrderAttr]
                    });
                }

                showDirectOrderPreview();
            } else {
                vm.d.directOrder = 'no';
                if (tradeInfo.priceSetting === 'uniform') {

                    // 交易信息
                    vm.d.tradeLadderInfo.list = [];
                    vm.d.tradeLadderInfo.preview = [];

                    if (isEmptyObject(tradeInfo.quantityPrice)) {
                        vm.d.tradeLadderInfo.list.push({
                            order: '',
                            price: ''
                        });
                    }

                    vm.d.tradeMode = 'ladder';
                    for (var i5 = 0; i5 < vm.d.tradeLadderMeasureUnitsInfo.list.length; i5++) {
                        if (tradeInfo.measureUnit === vm.d.tradeLadderMeasureUnitsInfo.list[i5]) {
                            vm.d.tradeLadderMeasureUnitsInfo.selected = vm.d.tradeLadderMeasureUnitsInfo.list[i5];
                            break;
                        }
                    }

                    for (var attr in tradeInfo.quantityPrice) {
                        var price = {
                            order: attr,
                            price: tradeInfo.quantityPrice[attr]
                        };

                        vm.d.tradeLadderInfo.list.push(price);
                    }

                    showTradeLadderPreview();
                } else {
                    vm.d.tradeMode = 'single';

                    for (var i9 = 0; i9 < vm.d.tradeSingleMeasureUnitsInfo.list.length; i9++) {
                        if (tradeInfo.measureUnit === vm.d.tradeSingleMeasureUnitsInfo.list[i9]) {
                            vm.d.tradeSingleMeasureUnitsInfo.selected = vm.d.tradeSingleMeasureUnitsInfo.list[i9];
                            break;
                        }
                    }

                    for (var i10 = 0; i10 < vm.d.currencyInfo.list.length; i10++) {
                        if (tradeInfo.moneyKind === vm.d.currencyInfo.list[i10]) {
                            vm.d.currencyInfo.selected = vm.d.currencyInfo.list[i10];
                            break;
                        }
                    }

                    for (var attr3 in tradeInfo.quantityPrice) {
                        var price2 = tradeInfo.quantityPrice[attr3].split('-');
                        vm.d.tradeSingleInfo.orderMin.value = attr3;
                        vm.d.tradeSingleInfo.priceMin.value = price2[0];
                        vm.d.tradeSingleInfo.priceMax.value = price2[1];
                    }

                    if (tradeInfo.addInfo) {
                        vm.d.tradeSingleInfo.addInfo.show = true;
                        vm.d.tradeSingleInfo.addInfo.value = tradeInfo.addInfo;
                    }
                }
            }

            Array.isArray(form.deliveryDate) && form.deliveryDate.length && (vm.d.deliveryDateInfo.list = form.deliveryDate.map(function (element) {
                return element;
            }));
            form.deliveryDate = [];

            vm.packageImage.list = [].concat(form.packingImgs);
            form.packingImgs = [];

            // 支付方式
            var payMethod = ['L/C', 'D/A', 'D/P', 'T/T', 'Western Union', 'MoneyGram'];
            tradeInfo.paymentMethod = tradeInfo.paymentMethod || [];
            for (var attr2 in vm.d.payMethod) {
                for (var i6 = 0; i6 < tradeInfo.paymentMethod.length; i6++) {

                    if (vm.d.payMethod[attr2].value === tradeInfo.paymentMethod[i6]) {
                        vm.d.payMethod[attr2].selected = true;
                    }

                    if (payMethod.indexOf(tradeInfo.paymentMethod[i6]) === -1) {
                        vm.d.payMethod.other.selected = true;
                        vm.d.payMethod.other.value = tradeInfo.paymentMethod[i6];
                    }
                }
            }

            // 供货能力
            form.supplyAbility = form.supplyAbility || {};

            vm.d.supplyInfo.number = form.supplyAbility.count;

            for (var i7 = 0; i7 < vm.d.timeUnitsInfo.list.length; i7++) {
                if (vm.d.timeUnitsInfo.list[i7].value === form.supplyAbility.timeUnit) {
                    vm.d.timeUnitsInfo.selected = vm.d.timeUnitsInfo.list[i7];
                    break;
                }
            }

            for (var i8 = 0; i8 < vm.d.packageMeasureUnitsInfo.list.length; i8++) {
                if (vm.d.packageMeasureUnitsInfo.list[i8].value === form.supplyAbility.measureUnit) {
                    vm.d.packageMeasureUnitsInfo.selected = vm.d.packageMeasureUnitsInfo.list[i8];
                    break;
                }
            }


            if (form.addInfo) {
                vm.d.supplyInfo.addInfo.show = true;
                vm.d.supplyInfo.addInfo.text = form.addInfo;
            }

            // 特殊服务
            if (form.sampleService === '3') {
                vm.d.specialService.type = 'no';
            } else if (form.sampleService === '2') {
                vm.d.specialService.type = 'requestSampleFree';
            } else if (form.sampleService === '1') {
                vm.d.specialService.type = 'orderSample';
                vm.d.specialService.maxSample = form.maxSample;
                vm.d.specialService.samplePrice = form.samplePrice;

                for (var j = 0; j < constantStore.MEASURE_UNITS_OBJ_ARRAY.length; j++) {
                    if (form.sampleUint === constantStore.MEASURE_UNITS_OBJ_ARRAY[j].value) {
                        vm.d.specialService.measureUnit.selected = constantStore.MEASURE_UNITS_OBJ_ARRAY[j];
                        break;
                    }
                }
            }
            
            if(form.directlyOrder === 0) {
                // 回填物流模式勾选
                var logisticsModelArray = form.logisticsInfo.logisticsModel.split(",");
                for(var i in vm.d.logisticsModel) {
                    vm.d.logisticsModel[i] = $.inArray(i, logisticsModelArray) !== -1;
                }
            }
            else {
                // 回填运费模板选中项
                var shipTemplatesInfo = vm.d.shipTemplatesInfo;
                var selectedArray = shipTemplatesInfo.list.filter(function(item) {
                    return item.value == form.logisticsInfo.feightTmpl.id;
                })
                //如果原本没有勾选记录，则默认勾选第一项
                if(selectedArray.length > 0) {
                    shipTemplatesInfo.selected = selectedArray[0];
                }
                else {
                    shipTemplatesInfo.selected = shipTemplatesInfo.list[0];
                }
            }
        }

        /*************************格式校验函数**************************/

        // 验证器 返回错误信息
        function validatorFn(type, text) {
            console.log(type)
            console.log(text)
            text = text || {
                requiredName: '',
                filed: '',
                maxlength: 128,
                atLeastOne: '',
                intMax: 9,
                decimalMax: 2,
                cn: ''
            };
            var validator = {
                required: text.requiredName + '不能为空',
                atLeastOne: '请至少填写一个' + text.atLeastOne,
                maxlength: text.filed + '允许输入最多' + text.maxlength + '个字符',
                price: text.filed + '请输入有效的数字，英文输入法的句号(.)',
                number: '请输入数字。',
                numberAndHyphen: '只允许输入数字和中横线符号。',
                numberGreatZero: '数字必须大于0',
                pInteger: '无效起订量：请输入1-999999999的整数',
                precision: '无效' + text.filed + '：请输入0.01-999999999.99之间的数值, 并精确到小数点后2位',
                onlyEnglish: '请不要输入如下非英文字符：' + text.cn,
                orderMinAscending: '最小起订量必须是由小到大',
                priceDescending: '价格必须由大到小'
            };

            return validator[type];
        }

        /**************************页面操作函数*******************************/

        // 添加更多关键词
        function addMoreKeyword() {
            if (vm.d.keywords.length >= 3) {
                return;
            }
            
            vm.d.keywords.push({
                value: '',
                placeholder: '',
                err: ''
            });
        }

        // 移除关键词
        function removeKeyword(index) {
            index in vm.d.keywords && vm.d.keywords.splice(index, 1);
        }

        // 操作自定义属性
        function moveCustomAttrs(option, index) {

            switch (option) {
                case 'add':
                    addMoreCustomAttrs();
                    break;
                case 'delete':
                    delCustomAttrs(index);
                    break;
                default:
                    move(option, index);
            }

            // 添加自定义属性
            function addMoreCustomAttrs() {

                if (vm.d.customAttrs.length >= 10) {
                    return;
                }

                var attrs = {
                    name: '',
                    value: '',
                    nameError: '',
                    valueError: ''
                };
                vm.d.customAttrs.push(attrs);
            }

            // 删除自定义属性
            function delCustomAttrs(index) {
                vm.d.customAttrs.splice(index, 1);
            }

            // 移动自定义属性
            function move(option, index) {

                var beList = vm.d.customAttrs;

                var newIndex = option === 'up' ? (index - 1) : (index + 1);

                if (newIndex > beList.length || newIndex < 0) {
                    return;
                }

                var beHandleCustomAttr = beList[index];

                if (option === 'up') {
                    beList.splice(newIndex, 0, beHandleCustomAttr);
                    beList.splice(index + 1, 1);
                } else {
                    beList.splice(newIndex + 1, 0, beHandleCustomAttr);
                    beList.splice(index, 1);
                }
            }

        }

        // 操作产品规格
        function moveProductSpec(option, index) {

            switch (option) {
                case 'add':
                    add();
                    break;
                case 'delete':
                    del(index);
                    break;
                default:
                    move(option, index);
            }

            // 添加产品规格
            function add() {
                if (vm.d.productSpec.length >= 10) {
                    return;
                }

                vm.d.productSpec.push({value: ''});
            }

            // 删除产品规格
            function del(index) {
                vm.d.productSpec.splice(index, 1);
            }

            // 移动产品规格
            function move(option, index) {

                var beList = vm.d.productSpec;

                var newIndex = option === 'up' ? (index - 1) : (index + 1);

                if (newIndex > beList.length || newIndex < 0) {
                    return;
                }

                var beHandleCustomAttr = beList[index];

                if (option === 'up') {
                    beList.splice(newIndex, 0, beHandleCustomAttr);
                    beList.splice(index + 1, 1);
                } else {
                    beList.splice(newIndex + 1, 0, beHandleCustomAttr);
                    beList.splice(index, 1);
                }
            }

        }

        // 显示或关闭对应下拉菜单
        function showDropDownMenu(type, e) {

            e.stopPropagation();
            vm.d[type].showList = !vm.d[type].showList;
        }

        // FOB单一区间价
        function ctrlTradeSingleAddInfo(option) {

            vm.d.tradeSingleInfo.addInfo.show = option;

            if (!option) {
                vm.d.tradeSingleInfo.addInfo.value = '';
                vm.d.tradeSingleInfo.addInfo.errMsg = '';
            }
        }

        // FOB单一区间价
        function ctrlSupplyAddInfo(option) {

            vm.d.supplyInfo.addInfo.show = option;

            if (!option) {
                vm.d.supplyInfo.addInfo.text = '';
                vm.d.supplyInfo.addInfo.errMsg = '';
            }
        }

        // FOB阶梯价添加价格区间
        function ctrlTradeLadderInput(option, index) {
            var list = vm.d.tradeLadderInfo.list;
            if (option === 'add') {
                if (list.length >= 4) {
                    return;
                }

                var ladder = {
                    order: '',
                    price: ''
                };

                vm.d.tradeLadderInfo.list.push(ladder);
            } else {
                vm.d.tradeLadderInfo.list.splice(index, 1);
                showTradeLadderPreview();
            }
        }

        function ctrlDirectOrderInput(option, index) {
            var list = vm.d.directOrderInfo.list;
            if (option === 'add') {
                if (list.length >= 3) {
                    return;
                }

                var ladder = {
                    order: '',
                    price: ''
                };

                vm.d.directOrderInfo.list.push(ladder);
            } else {
                vm.d.directOrderInfo.list.splice(index, 1);
                showDirectOrderPreview();
            }
        }

        function ctrlDeliveryInfoInput(option, index) {
            var list = vm.d.deliveryDateInfo.list;
            if (option === 'add') {
                if (list.length >= 3) {
                    return;
                }

                var info = {
                    num: '',
                    day: ''
                };

                vm.d.deliveryDateInfo.list.push(info);
            } else {
                vm.d.deliveryDateInfo.list.splice(index, 1);
                showDeliveryInfoPreview();
            }
        }

        /*********************分组相关函数************************/

        // 控制分组窗口
        function ctrlGroupWindow(e, option) {
            e && e.stopPropagation();

            vm.d.groupInfo.showList = option ? option === 'open' : !vm.d.groupInfo.showList;
            vm.d.isAddGroup && ctrlAddGroupInput('close');
            clearSelect();
        }

        // 控制添加分组input框
        function ctrlAddGroupInput(option) {
            layer.open({
                title: '创建新分组',
                resize: false,
                move: false,
                skin: 'add-group-dialog',
                btn: ['保存'],
                content: [
                    '<div>',
                    '<input id="add-group-value" type="text" maxlength="128" onkeyup="document.getElementById(\'add-group-word-count\').innerText = this.value.length + \'/128\';">',
                    '<span id="add-group-word-count">0/128</span>',
                    '</div>'
                ].join(''),
                area: ['360px', '128px'],
                btn1: function (index) {
                    var group = document.getElementById('add-group-value').value;
                    if (!group) {
                        DSSX.dialog.msg('分组名字不能为空');
                        return false;
                    }

                    if (group.length > 128) {
                        DSSX.dialog.msg('分组名字过长');
                        return false;
                    }

                    request.get('/usr/api/updateProductGroup', {
                        method: 'add',
                        groups: group
                    }, true).then(function (res) {
                        DSSX.dialog.msg('添加成功');
                        loadGroups();
                    }, function (err) {
                        DSSX.dialog.err(error, {
                            moduleName: 'product-form.js',
                            funcName: 'addNewGroup',
                            text: '添加分组失败'
                        });
                    }).finally(function () {
                        layer.close(index);
                    });
                }
            })
        }

        // 加载分组
        function loadGroups() {

            request.get('/usr/api/listProductGroup', {}, true)
                .then(callback, errCallback);

            function callback(res) {
                var list = util.safe(res, 'data.groups', []);
                var result = [];
                vm.d.groupInfo.array = list.concat(['未分组']);
                for (var i = 0; i < list.length; i++) {
                    var group = {
                        name: list[i],
                        selected: false
                    };
                    result.push(group);
                }
                vm.d.groupInfo.list = result.concat([{name: '未分组', selected: false}]);
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'product-form.js',
                    funcName: 'loadGroups',
                    text: '加载分组失败'
                });
            }
        }

        // 添加新分组
        function addNewGroup() {
            var cn = checkFormData.findCN(vm.d.newGroup);

            if (!vm.d.newGroup) {
                layer.msg('组名不能为空');
                return;
            }

            if (cn) {
                layer.msg('请不要输入如下非英文字元:' + cn);
                return;
            }

            if (vm.d.groupInfo.array.indexOf(vm.d.newGroup) !== -1) {
                layer.msg('该分组已经存在');
                return;
            }

            var params = {
                method: 'add',
                groups: vm.d.newGroup
            };

            request.get('/usr/api/updateProductGroup', params, true)
                .then(callback, errCallback);

            function callback(res) {
                ctrlAddGroupInput('close');
                loadGroups();
            }

            function errCallback(error) {
                DSSX.dialog.err(error, {
                    moduleName: 'product-form.js',
                    funcName: 'addNewGroup',
                    text: '添加分组失败'
                });
            }

        }

        // 选则分组
        function selectGroup(group) {
            vm.d.groupInfo.selected = group.name;
            clearSelect();
            group.selected = true;
            submitGroup();
        }

        // 清除分组的选中状态
        function clearSelect() {
            for (var i = 0; i < vm.d.groupInfo.list.length; i++) {
                vm.d.groupInfo.list[i].selected = false;
            }
        }

        // 提交选中的分组
        function submitGroup() {
            ctrlGroupWindow();
            vm.d.form.group = vm.d.groupInfo.selected;
            countBasicInfoPer();
        }

        /*************************文件相关函数*************************/
        function uploader(event) {
            vm.d.files.showErrorMsg = false;
            var beUploadFilesInfo = getBeUploadFiles(event.files, vm.d.files.list);
            var files = beUploadFilesInfo.list;

            removeProductImageFileErrorMsg();

            vm.d.fileErrorMsg = beUploadFilesInfo.checkResult.errTypeFiles.concat(beUploadFilesInfo.checkResult.errSizeFiles);

            if (beUploadFilesInfo.moreSix) {
                vm.d.fileErrorMsg.push({
                    showIcon: false,
                    info: '最多只允许上传 6 个文件'
                });
            }

            for (var i = 0; i < files.length; i++) {
                startUpload(files[i]);
            }

            // 获取准备上传的文件
            function getBeUploadFiles(beUploadFiles, uploadedFiles) {
                var remain = 6 - uploadedFiles.length;
                var checkResult = checkUploadFile(beUploadFiles);

                if (uploadedFiles.length + checkResult.validFiles.length <= 6) {
                    return {
                        list: checkResult.validFiles,
                        moreSix: false,
                        checkResult: checkResult
                    };
                }

                if (uploadedFiles.length + checkResult.validFiles.length > 6) {
                    return {
                        list: checkResult.validFiles.slice(0, remain),
                        moreSix: true,
                        checkResult: checkResult
                    };
                }
            }

            // 文件校验
            function checkUploadFile(fileList) {
                var result = [];
                var errTypeFiles = [];
                var errSizeFiles = [];

                for (var i = 0, len = fileList.length; i < len; i++) {

                    var type = fileList[i].name.slice(fileList[i].name.lastIndexOf('.') + 1);

                    if (FILE_TYPE.indexOf(type) === -1) {
                        errTypeFiles.push({
                            showIcon: true,
                            info: fileList[i].name + ' 文件类型错误'
                        });
                        continue;
                    }

                    if (fileList[i].size > MAX_FILE_SIZE) {
                        errSizeFiles.push({
                            showIcon: true,
                            info: fileList[i].name + ' 文件大小大于5M'
                        });
                        continue;
                    }

                    result.push(fileList[i]); // 有效产品
                }

                return {
                    errTypeFiles: errTypeFiles,
                    errSizeFiles: errSizeFiles,
                    validFiles: result
                }
            }

            // 开始上传
            function startUpload(file) {
                vm.d.files.num++;
                // 准备上传 占个位置
                var fileInfo = {
                    id: 'prod-file-' + vm.d.files.num, // 独一无二的id
                    fileUrl: '',
                    fileName: file.name,
                    size: file.size,
                    uploadStatus: 'beUpload', // beUpload 准备上传  uploading 上传中 completed 上传完成 fail 上传失败
                    progress: {
                        totalSize: file.size,
                        loadedSize: 0
                    }
                };

                vm.d.files.list.push(fileInfo);
                vm.d.files.progress.totalSize += fileInfo.size;
                vm.d.files.progress.show = ctrlProgressStatus(vm.d.files.list);

                getFilesNum();
                // 开始上传
                fileUploaderService.start(file, getFileUploadAddress(), vm.d.files, fileInfo.id)
                    .then(callback, errCallback);

            }

            // 上传成功
            function callback(res) {
                var index = res.data.indexOf('/');
                var sentFile = {
                    url: res.data.slice(index)
                    // name: res.base.filename
                };

                $('#upload-file-btn').val('');

                // 前端显示的格式
                handleFile(vm.d.files.list);
                // 传给后台的文件格式
                vm.d.files.sentFiles.push(sentFile);
                vm.d.files.progress.show = ctrlProgressStatus(vm.d.files.list); // 显示总的进度条

                // 将上传的文件处理为前端显示的格式
                function handleFile(files) {

                    for (var i = 0; i < files.length; i++) {
                        if (files[i].uploadStatus !== 'completed' && files[i].id === res.fileId) {
                            sentFile.name = files[i].fileName;
                            files[i].fileUrl = res.data;
                            files[i].uploadStatus = 'completed'; // 上传完成

                            if (vm.d.files.progress.loadedSize >= vm.d.files.progress.totalSize) {
                                vm.d.files.progress.totalSize = 0;
                            }
                            getFilesNum();
                            return;
                        }
                    }
                }
            }

            function errCallback(error) {

                var failedFileInfo = error.failedFileInfo;
                var list = vm.d.files.list;

                for (var i = 0; i < list.length; i++) {
                    if (list[i].id === failedFileInfo.id) {
                        list[i].uploadStatus = 'fail';
                        list[i].progress.loadedSize = 0;
                        break;
                    }
                }

                vm.d.files.progress.show = ctrlProgressStatus(vm.d.files.list); // 显示总的进度条

                DSSX.dialog.err(error, {
                    moduleName: 'product-form.js',
                    funcName: 'uploader',
                    text: '文件上传失败'
                });
            }
        }

        // 控制进度条状态
        function ctrlProgressStatus(files) {
            var result = [];
            for (var i = 0; i < files.length; i++) {

                var status = false;

                if (files[i].uploadStatus === 'completed') {
                    status = true;
                }

                if (files[i].uploadStatus === 'fail') {
                    status = true;
                }

                result.push(status);
            }
            return result.indexOf(false) !== -1; // true 还有正在上传的文件
        }

        // 文件上传地址
        function getFileUploadAddress() {
            return '//' + DSSX.host.fs + '/usr/api/uload?pub=1';
        }

        // 全部取消
        function cancelAllUploadingFile() {

            for (var i = 0; i < vm.d.files.list.length; i++) {
                if (vm.d.files.list[i].uploadStatus !== 'completed') {
                    cancelUploadingFile(vm.d.files.list[i], i);
                    i = 0;
                }
            }

            vm.d.files.progress.show = ctrlProgressStatus(vm.d.files.list);
        }

        // 取消正在上传的文件
        function cancelUploadingFile(file, index) {

            var files = vm.d.files;
            fileUploaderService.cancel(file.id);
            (files.progress.totalSize > 0) && (files.progress.totalSize -= file.size);
            files.list.splice(index, 1);
            $('#upload-file-btn').val('');
            getFilesNum();
            vm.d.files.progress.show = ctrlProgressStatus(vm.d.files.list); // 显示总的进度条
            removeProductImageFileErrorMsg();
        }

        // 计算 已上传文件 待上传文件 剩余上传文件 数量
        function getFilesNum() {
            var files = vm.d.files;
            var count = getUploadedFilesNum(files.list);
            files.uploadedNum = count.uploadedNum;
            files.beUploadNum = count.beUploadNum;
            files.remainUploadNum = count.remainUploadNum;

            function getUploadedFilesNum(files) {
                var uploadedNum = 0;
                var beUploadNum = 0;
                var remainUploadNum = 0;

                for (var i = 0; i < files.length; i++) {
                    if (files[i].uploadStatus === 'completed') {
                        uploadedNum++;
                    }
                    beUploadNum = files.length - uploadedNum;
                    remainUploadNum = 6 - files.length;
                }
                return {
                    uploadedNum: uploadedNum,
                    beUploadNum: beUploadNum,
                    remainUploadNum: remainUploadNum
                };
            }
        }

        // 移除已上传的文件
        function removeFile(index) {
            vm.d.files.list.splice(index, 1);
            vm.d.files.sentFiles.splice(index, 1);
            getFilesNum();

            removeProductImageFileErrorMsg();
        }

        // 全部移除
        function removeAllFile() {
            cancelAllUploadingFile();

            vm.d.files.list = [];
            vm.d.files.sentFiles = [];

            removeProductImageFileErrorMsg();
        }

        // 移除 产品图片 模块文件错误消息
        function removeProductImageFileErrorMsg() {
            vm.d.fileErrorMsg = [];
        }

        // 初始化图片银行
        function initPhotoBank() {
            var openBtn = $('.photo-bank-show-btn');
            openBtn.click(openPhotoBankPopSelect);

            function openPhotoBankPopSelect() {
                window.photoBankSelectCallBack = photoBankSelectCallBack;
                var count = getSelectedPhotoCount();
                if (count >= 6) {
                    layer.alert("最多允许上传6个图片");
                    return;
                }

                layer.open({
                    type: 2,
                    title: 0,
                    closeBtn: 0,
                    area: ["982px", "642px"],
                    content: ['iframe/photo-bank/pop-select.html', 'no'],
                    success: openSuccess
                });

                function openSuccess(layero, index) {
                    var iframeWin = window[layero.find('iframe')[0]['name']];

                    iframeWin.dataTransfer && iframeWin.dataTransfer('imgMax', 6 - count);
                }
            }

            function photoBankSelectCallBack(data) {
                console.log('photoBankSelectCallBack', data);
                var list = [];
                var sentFiles = [];
                for (var i = 0; i < data.length; i++) {

                    vm.d.files.num++;
                    var pic = {
                        id: 'prod-file-' + vm.d.files.num,
                        fileUrl: data[i].img,
                        fileName: data[i].name,
                        size: 100,
                        uploadStatus: 'completed',
                        progress: {
                            totalSize: 100,
                            loadedSize: 100
                        }
                    };
                    var sentFile = {
                        url: data[i].img,
                        name: data[i].name
                    };

                    list.push(pic);
                    sentFiles.push(sentFile);
                }

                $timeout(function () {
                    vm.d.files.list = vm.d.files.list.concat(list);
                    vm.d.files.sentFiles = vm.d.files.sentFiles.concat(sentFiles);
                    window.photoBankSelectCallBack = null;
                });
            }

            function getSelectedPhotoCount() {
                return vm.d.files.list.length;
            }

        }

        /***********************表单相关************************/

        // 下拉框选择完成
        function selectDropDownFinish(event, type) {
            vm.d[type].selected = event.selectItem;
            checkFormData.checkDirectOrderUnit();
            countTradeInfoPer();

        }

        // 预览阶梯价
        function showTradeLadderPreview() {
            countTradeInfoPer();
            var ladderList = vm.d.tradeLadderInfo.list;
            for (var i = 0; i < ladderList.length; i++) {
                checkFormData.checkTradeLadderOrder(i);
                checkFormData.checkTradeLadderPrice(i);
            }

            vm.d.tradeLadderInfo.showPreview = !(vm.d.errMsg.tradeLadder.order || vm.d.errMsg.tradeLadder.price);
            if (!vm.d.tradeLadderInfo.showPreview) {
                return;
            }
            var list = vm.d.tradeLadderInfo.list;
            var previewList = [];
            var result = [];

            for (var k = 0; k < list.length; k++) {
                if (list[k].order && list[k].price) {
                    // let obj = { order: list[k].order, price: list[k].price }
                    // if (vm.d.saleMethod === 'byBatch') {
                    //     obj.order = obj.order * vm.d.directOrderInfo.batchUnit;
                    // }
                    previewList.push(list[k]);
                }
            }

            for (var j = 0; j < previewList.length; j++) {
                var preview;
                if (j === previewList.length - 1) {
                    preview = {
                        order: '≥' + previewList[j].order,
                        price: previewList[j].price
                    };
                } else {
                    preview = {
                        order: previewList[j].order + '~' + ((+previewList[j + 1].order) - 1),
                        price: previewList[j].price
                    };
                }
                result.push(preview);
            }

            vm.d.tradeLadderInfo.preview = result;
        }

        function showDirectOrderPreview() {
            countTradeInfoPer();
            var ladderList = vm.d.directOrderInfo.list;
            for (var i = 0; i < ladderList.length; i++) {
                checkFormData.checkDirectOrderOrder(i);
                checkFormData.checkDirectOrderPrice(i);
            }

            vm.d.directOrderInfo.showPreview = !(vm.d.errMsg.directOrder.order || vm.d.errMsg.directOrder.price);
            if (!vm.d.directOrderInfo.showPreview) {
                return;
            }
            var list = vm.d.directOrderInfo.list;
            var previewList = [];
            var result = [];

            for (var k = 0; k < list.length; k++) {
                if (list[k].order && list[k].price) {
                    var obj = { order: list[k].order, price: list[k].price }
                    if (vm.d.saleMethod === 'byBatch') {
                        obj.order = obj.order * vm.d.directOrderInfo.batchUnit;
                    }
                    previewList.push(obj);
                }
            }

            for (var j = 0; j < previewList.length; j++) {
                var preview;
                if (j === previewList.length - 1) {
                    preview = {
                        order: '≥' + previewList[j].order,
                        price: previewList[j].price
                    };
                } else {
                    preview = {
                        order: previewList[j].order + '~' + ((+previewList[j + 1].order) - 1),
                        price: previewList[j].price
                    };
                }
                result.push(preview);
            }

            vm.d.directOrderInfo.preview = result;
        }

        // 发货信息
        function showDeliveryInfoPreview() {
            vm.d.deliveryDateInfo.showPreview = (checkFormData.checkDeliveryInfo('num') && checkFormData.checkDeliveryInfo('day'))
                && !(vm.d.deliveryDateInfo.list.length === 1 && vm.d.deliveryDateInfo.list[0].num === '' && vm.d.deliveryDateInfo.list[0].day === '');

            if (!vm.d.deliveryDateInfo.showPreview) {
                return;
            }

            var result = [];
            for (var i = 0; i < vm.d.deliveryDateInfo.list.length; i++) {
                if (i === 0) {
                    result.push({
                        num: 1 + '~' + vm.d.deliveryDateInfo.list[i].num,
                        day: vm.d.deliveryDateInfo.list[i].day + '天'
                    });
                } else {
                    result.push({
                        num: (parseInt(vm.d.deliveryDateInfo.list[i - 1].num, 10) + 1) + '~' + vm.d.deliveryDateInfo.list[i].num,
                        day: vm.d.deliveryDateInfo.list[i].day + '天'
                    });
                }

                if (i === vm.d.deliveryDateInfo.list.length - 1) {
                    result.push({
                        num: '≥ ' + (parseInt(vm.d.deliveryDateInfo.list[i].num) + 1),
                        day: '需要协商'
                    });
                }
            }

            vm.d.deliveryDateInfo.preview = result;
            countPackageInfoPer();
        }

        // 清除支付方式的错误信息
        function clearPayMethodErrorMsg() {
            countTradeInfoPer();
            if (!vm.d.payMethod.other.selected) {
                vm.d.errMsg.payMethod = '';
            }
        }

        // 产品评分：完成度百分比×4.8
        function getFormScore() {
            if (!checkCoreForm()) {
                return;
            }
            vm.c.totalScore = -1;
            $timeout(function () {
                vm.c.scoreList.forEach(function (value, index) {
                    vm.c.scoreList[index].scoreCopy = value.scoreNum;
                    vm.c.scoreList[index].showDetail = false;
                });
                vm.c.totalScore = vm.c.totalRateProgress * 4.8 / 100;
            }, 500);
        }

        // 检查各项分数
        function checkAllFull() {
            var result = [];
            vm.c.scoreList.forEach(function (value, index) {
                if (index === vm.c.scoreList.length - 1) {
                    return;
                }
                result.push(value.scoreCopy === 100);
            });

            return result.indexOf(false) === -1;
        }

        // 展开评分详情
        function showScoreDetail(arg_index) {
            if (!(arg_index in vm.c.scoreList)) {
                return;
            }

            vm.c.scoreList[arg_index].showDetail = !vm.c.scoreList[arg_index].showDetail;
        }

        // 校验核心字段
        function checkCoreForm() {
            return vm.d.form.productName.length && (vm.d.keywords.length && vm.d.keywords[0].value.length) && vm.d.files.list.length;
        }

        // 全局校验表单 //
        function globalCheckForm() {
            var result = [];

            // 基本信息校验
            result.push(checkFormData.checkProductName());
            result.push(checkFormData.checkKeyword());
            result.push(checkFormData.checkModel());
            result.push(checkFormData.checkBrand());
            result.push(checkFormData.checkDeliveryInfo('num'), checkFormData.checkDeliveryInfo('day'));
            for (var i = 0; i < vm.d.customAttrs.length; i++) {
                result.push(checkFormData.checkCustomAttrs(i));
            }

            // 文件的校验
            if (vm.d.files.sentFiles.length <= 0) {
                vm.d.files.showErrorMsg = true;
                result.push(false);
            }

            // 产品详细信息校验

            if (vm.d.editMode === 'smart') {
                console.info(editorInfo, editorInfo.preview);
                if (editorInfo.preview) {
                    if (editorInfo.preview.indexOf("imgs/editor-05.png") > -1
                        || editorInfo.preview.indexOf("imgs/editor-6-1.png") > -1
                        || editorInfo.preview.indexOf("imgs/editor-6-2.png") > -1
                        || editorInfo.preview.indexOf("imgs/editor-6-3.png") > -1
                        || editorInfo.preview.indexOf("imgs/editor-7-10.png") > -1
                        || editorInfo.preview.indexOf("imgs/editor-7-2 .png") > -1
                        || editorInfo.preview.indexOf("imgs/editor-7-3.png") > -1) {

                        vm.d.errMsg.smartError = '请替换产品详情中的示例图';
                        result.push(false);
                        return;
                    }

                    vm.d.errMsg.smartError = '';
                }
            } else {
                if (normalEdit.remainWordCount < 0) {
                    layer.msg('编辑内容字数超出限制');
                    result.push(false);
                }

                if (normalEdit.remainImgCount < 0) {
                    layer.msg('编辑内容图片数量超出限制');
                    result.push(false);
                }
            }

            // 交易信息的校验

            if (vm.d.directOrder === 'yes') {
                result.push(checkFormData.checkDirectOrderUnit());
                result.push(checkFormData.checkDirectOrderOrder());
                result.push(checkFormData.checkDirectOrderPrice());
                result.push(checkFormData.checkBatchUnit());
            } else {
                if (vm.d.tradeMode === 'ladder') {
                    // FOB阶梯价
                    result.push(checkFormData.checkTradeLadderOrder());
                    result.push(checkFormData.checkTradeLadderPrice());
                    result = result.concat(checkFobLadderUnit());

                } else {
                    // FOB单一区间价
                    result.push(checkFormData.checkTradeSinglePrice());
                    result.push(checkFormData.checkTradeSingleOrderMin());

                    if (vm.d.tradeSingleInfo.addInfo.show) {
                        result.push(checkFormData.checkTradeSingleAddInfo());
                    }

                    // 校验计量单位 和 货币种类
                    result = result.concat(checkFobSingleUnit('all'));
                }
            }

            if (vm.d.payMethod.other.selected) {
                result.push(checkFormData.checkPayMethod());
            }

            // 物流信息校验
            result.push(checkFormData.checkDeliveryTime());
            result.push(checkFormData.checkHarbor());
            result.push(checkFormData.checkSupplyInfo());
            result.push(checkFormData.checkPacking());

            if (vm.d.supplyInfo.addInfo.show) {
                result.push(checkFormData.checkSupplyAddInfo());
            }

            if(vm.d.directOrder !== 'yes') {
                result.push(checkFormData.checkLogisticsModel());
            } else {
                result.push(checkFormData.checkGrossWeightPerProduct());
                result.push(checkFormData.checkSizePerProduct());
                result.push(checkFormData.checkShipTemplate());
            }

            // 特殊服务校验
            if (vm.d.specialService.type === 'orderSample') {
                result.push(checkFormData.checkMaxSample());
                result.push(checkFormData.checkSamplePrice());
                result.push(checkFormData.checkSpecialServiceMeasureUnit());
            }

            return !(result.indexOf(false) !== -1);
        }

        function checkFobLadderUnit() {
            var result = [];
            var list = vm.d.tradeLadderInfo.list;
            vm.d.errMsg.tradeLadder.measure = '';

            var needCheck = list.some(function (item, index, array) {
                if (array[index].order || array[index].price) {
                    return true;
                }
            });

            if (needCheck) {
                vm.c.needCheckLadderMeasureUnit = true;
                if (vm.d.tradeLadderMeasureUnitsInfo.selected === '计量单位') {
                    vm.d.errMsg.tradeLadder.measure = '计量单位不能为空。';
                    result.push(false);
                }
                result.push(true);
            } else {
                vm.c.needCheckLadderMeasureUnit = false;
            }

            return result;
        }

        function checkFobSingleUnit(type) {
            // 校验计量单位 和 货币种类
            var result = [];
            vm.d.tradeSingleInfo.currencyUnit.errMsg = '';
            vm.d.tradeSingleInfo.measureUnit.errMsg = '';
            if (vm.d.tradeSingleInfo.priceMin.value || vm.d.tradeSingleInfo.priceMax.value) {

                if (type === 'currency') {
                    if (vm.d.currencyInfo.selected === '货币种类') {
                        vm.d.tradeSingleInfo.currencyUnit.errMsg = '货币种类不能为空。';
                        result.push(false);
                    }
                    result.push(true);
                }

                if (type === 'measure') {
                    if (vm.d.tradeSingleMeasureUnitsInfo.selected === '计量单位') {
                        vm.d.tradeSingleInfo.measureUnit.errMsg = '计量单位不能为空。';
                        result.push(false);
                    }
                    result.push(true);
                }

                if (type === 'all') {
                    if (vm.d.currencyInfo.selected === '货币种类') {
                        vm.d.tradeSingleInfo.currencyUnit.errMsg = '货币种类不能为空。';
                        result.push(false);
                    }
                    result.push(true);

                    if (vm.d.tradeSingleMeasureUnitsInfo.selected === '计量单位') {
                        vm.d.tradeSingleInfo.measureUnit.errMsg = '计量单位不能为空。';
                        result.push(false);
                    }
                    result.push(true);
                }
            }
            return result;
        }

        // 定位到错误信息位置
        function gotoErrorMsg() {
            var h1 = $('.err-msg:not(.ng-hide)').eq(0).offset().top - 50;
            $('html,body').animate({'scrollTop': h1}, 0, function () {
                $('.err').eq(0).focus();
            });
        }

        // 处理表单数据
        function handleFormData() {
            var form = angular.copy(vm.d.form);

            // 类目
            form.category = vm.d.category.enName || '';

            // 分组
            form.group = form.group || '未分组';

            // 关键词
            for (var i = 0; i < vm.d.keywords.length; i++) {
                if (vm.d.keywords[i].value) {
                    form.keyword.push(vm.d.keywords[i].value);
                }
            }

            // 自定义属性
            for (var j = 0; j < vm.d.customAttrs.length; j++) {
                if (vm.d.customAttrs[j].name) {
                    form.selfDefAttr.push({
                        name: vm.d.customAttrs[j].name,
                        value: vm.d.customAttrs[j].value
                    });
                }
            }

            // 商品规格
            vm.d.productSpec.forEach(function (element) {
                form.productSpec.push(element.value)
            });

            // 原产地
            var sourceland = {};
            if (vm.d.sourceAreaInfo.selected.label !== '--请选择--') {
                sourceland.country = vm.d.sourceAreaInfo.selected.label;
                sourceland.countryAbbr = vm.d.sourceAreaInfo.selected.value;
            } else {
                sourceland.country = '';
                sourceland.countryAbbr = '';
            }

            if (vm.d.provinceInfo.selected && vm.d.provinceInfo.selected.label !== '--请选择--') {
                sourceland.province = vm.d.provinceInfo.selected.label;
                sourceland.provinceAbbr = vm.d.provinceInfo.selected.value;
            } else {
                sourceland.province = '';
                sourceland.provinceAbbr = '';
            }

            form.sourceland = sourceland;

            // 产品图片
            form.imgs = vm.d.files.sentFiles;

            if (vm.d.editMode === 'normal') {
                form.normalEdit = normalEdit.text;
                form.detailDesc = null;
            } else {
                form.detailDesc = {
                    items: editorInfo.items,
                    preview: editorInfo.preview
                };
                form.normalEdit = '';
            }

            // 交易信息
            form.tradeInfo.isBuyoutPrice = false; // 是否支持一口价

            if (vm.d.directOrder === 'yes') {
                form.directlyOrder = 1;
                form.tradeInfo.measureUnit = vm.d.directOrderUnitsInfo.selected;
                form.tradeInfo.saleMethod = vm.d.saleMethod;
                form.tradeInfo.batchUnit = vm.d.directOrderInfo.batchUnit;
                form.tradeInfo.vendibleNum = +vm.d.directOrderInfo.vendibleNum;
                form.tradeInfo.quantityPrice = {};
                vm.d.directOrderInfo.list.forEach(function (value) {
                    value.order && value.price && (form.tradeInfo.quantityPrice[value.order] = value.price);
                });

            } else {
                form.directlyOrder = 0;
                if (vm.d.tradeMode === 'ladder') {
                    // FOB阶梯价
                    form.tradeInfo.priceSetting = 'uniform';
                    form.tradeInfo.measureUnit = vm.d.tradeLadderMeasureUnitsInfo.selected;
                    var list = vm.d.tradeLadderInfo.list;
                    form.tradeInfo.quantityPrice = {};
                    for (var k = 0; k < list.length; k++) {

                        if (list[k].order && list[k].price) {
                            form.tradeInfo.quantityPrice[list[k].order] = list[k].price;
                        }
                    }

                } else {
                    // FOB单一区间价
                    var
                        orderMin = vm.d.tradeSingleInfo.orderMin.value,
                        priceMin = vm.d.tradeSingleInfo.priceMin.value,
                        priceMax = vm.d.tradeSingleInfo.priceMax.value
                    ;

                    form.tradeInfo.priceSetting = 'fob';
                    form.tradeInfo.measureUnit = vm.d.tradeSingleMeasureUnitsInfo.selected;
                    form.tradeInfo.moneyKind = vm.d.currencyInfo.selected;
                    form.tradeInfo.addInfo = vm.d.tradeSingleInfo.addInfo.value;
                    form.tradeInfo.quantityPrice = {};

                    if (orderMin && priceMin && priceMax) {
                        form.tradeInfo.quantityPrice[orderMin] = priceMin + '-' + priceMax;
                    }

                }
            }

            vm.d.deliveryDateInfo.list.forEach(function (value) {
                if (value.num && value.day) {
                    form.deliveryDate.push(value);
                }
            });

            form.packingImgs = vm.packageImage.list;

            // 支付方式
            form.tradeInfo.paymentMethod = [];
            var payMethod = vm.d.payMethod;
            for (var attr in payMethod) {
                if (payMethod[attr].selected && payMethod[attr].value) {
                    form.tradeInfo.paymentMethod.push(payMethod[attr].value);
                }
            }

            // 物流信息
            form.addInfo = vm.d.supplyInfo.addInfo.text;
            var supplyAbility = '';
            var measureUnit = '';
            var timeUnit = '';

            if (vm.d.packageMeasureUnitsInfo.selected.label === '计量单位') {
                measureUnit = ' ';
            } else {
                measureUnit = vm.d.packageMeasureUnitsInfo.selected.value;
            }

            if (vm.d.timeUnitsInfo.selected.label === '时间单位') {
                timeUnit = '';
            } else {
                timeUnit = vm.d.timeUnitsInfo.selected.label;
            }

            if (vm.d.supplyInfo.number) {
                supplyAbility = vm.d.supplyInfo.number;
            } else {
                supplyAbility = '';
            }
            // form.supplyAbility = supplyAbility + '#' + measureUnit + '#' + timeUnit;
            form.supplyAbility = {
                count: supplyAbility,
                measureUnit: measureUnit,
                timeUnit: timeUnit
            };

            // 特殊服务
            if (vm.d.specialService.type === 'no') {
                form.sampleService = '3';
            } else if (vm.d.specialService.type === 'requestSampleFree') {
                form.sampleService = '2';
            } else if (vm.d.specialService.type === 'orderSample') {
                form.sampleService = '1';
                form.maxSample = vm.d.specialService.maxSample;
                form.samplePrice = vm.d.specialService.samplePrice;
                form.sampleUint = vm.d.specialService.measureUnit.selected.value;
            }

            if(form.directlyOrder !== 1) {
                // 格式化form的物流模式
                var logisticsModel = vm.d.logisticsModel;
                var logisticsModelArray = []
                for (var i in logisticsModel) {
                    if (logisticsModel[i]) {
                        logisticsModelArray.push(i);
                    }
                }
                form.logisticsInfo.logisticsModel = logisticsModelArray.toString();

                delete form.logisticsInfo.feightTmpl;
                delete form.logisticsInfo.grossWeightPerProduct;
                delete form.logisticsInfo.sizePerProduct;
                delete form.logisticsInfo.isRts;
            } else {
                // 处理物流信息属性
                form.logisticsInfo.grossWeightPerProduct = parseInt(form.logisticsInfo.grossWeightPerProduct);

                delete form.logisticsInfo.logisticsModel;
            }

            // 处理产品评分
            form.score = -1;
            if (checkCoreForm()) {
                vm.c.scoreList.forEach(function (value, index) {
                    vm.c.scoreList[index].scoreCopy = value.scoreNum;
                    vm.c.scoreList[index].showDetail = false;
                });
                form.score = parseFloat((vm.c.totalRateProgress * 4.8 / 100).toFixed(2));
            }

            return form;
        }

        // 提交表单
        function submit() {
            console.log(vm.d.directOrderInfo)
            if (!vm.d.isCheckAgain) {
                return;
            }

            var list = vm.d.directOrderInfo.list
            for (var i = 0; i < list.length; i++) {
                var order = list[i].order
                if (vm.d.saleMethod === 'byBatch' && (vm.d.directOrderInfo.batchUnit * order > 999999999)) {
                    layer.msg('起订量与批量的乘积不得大于999999999');
                    return;
                }
            }

            if(vm.d.directOrderInfo.vendibleNum > 999999999){
                layer.msg('可售数量过大，请输入1-999999999整数!');
                return;
            }

            normalEdit = vm.getNormalEditContent();

            var formIsPass = globalCheckForm();
            if (!formIsPass) {
                $timeout(function () {
                    gotoErrorMsg();
                });
                return;
            }

            if (commitProductPending) {
                layer.msg('已经在提交，请等待。。。');
                return;
            }

            commitProductPending = true;

            // 预览模式
            if (DSSX.attr.isPreviewMode) {
                DSSX.godMode.msg('预览模式只能查看，不能进行修改操作。');
                commitProductPending = false;
                return;
            }

            // isFirstProduct
            // true：
            //      代表当前处于国际站开通流程发布产品环节；并且当前产品和以前绑定的产品一致，或没有开通流程没有绑定过；
            var pid = util.queryString('productId');
            var lastFirstProdId = util.safe(DSSX, 'currUser.firstProdId', '');
            var isFirstProduct = util.queryString('first') === 'true' && DSSX.attr.state === 'publish_first_product';
            if (lastFirstProdId) {
                // 如果存在国际站开通流程绑定产品，判断是否当前产品
                isFirstProduct = isFirstProduct && pid === lastFirstProdId;
            }

            console.info(isFirstProduct, pid);

            var formData = handleFormData();
            var option = {
                isFirstProduct: isFirstProduct,
                pid: pid
            };

            // 根据产品类型定实训任务
            var interpolator = productTMInterpolator0
            if(formData.directlyOrder === 1) {
                interpolator = productTMInterpolator1
            }

            // 提交产品
            commitProduct2Service(formData, option)
                .then(commitSuc, commitErr)
                .then(updateUrlProductId)
                .then(aliInternationalStationHandler)
                .then(afterCommit)
                .then(stopAndDelSketch)
                .then(interpolator);

            // 提交产品信息成功
            function commitSuc(commitReturnData) {
                // 创建产品时，url 不存在 pid，从返回数据得到刚创建的 id
                pid || (pid = commitReturnData.productId || '');
                return {pid: pid}
            }

            function commitErr(err) {
                commitProductPending = false;
                DSSX.dialog.err(err, {
                    moduleName: 'product-form.js',
                    funcName: 'commitProduct2Service',
                    text: '产品发布失败'
                });
                console.log('[ProductFormCtrl] commitProduct2ServiceErr', err);
                return $q.reject(err);
            }

            // 更新 url 的 pid，如果需要
            function updateUrlProductId(option) {
                // pid 与 url 上不一致，更新 url；（目前只有pid原先不存在时需要更新）
                if (option.pid && util.queryString('pid') !== option.pid) {
                    var href = util.updateUrlSearch(location.href, 'productId', option.pid);
                    history.replaceState(null, '', href);
                }

                return option;
            }

            // 阿里国际站 状态处理
            function aliInternationalStationHandler(option) {
                if (isFirstProduct) {
                    return changeAccountStateAndBindPid(option);
                } else {
                    return option;
                }
            }

            // 提交产品信息成功后，页面状态处理
            //  1. 正常发布、编辑产品，切换布局
            //  2. 国际站开通流程-发布产品环节，跳回首页
            function afterCommit() {
                isFirstProduct ? jumpToHomePage() : switchPageLayout('commitSuccess');
                return pid;
            }

            // 删除和停止底稿功能
            function stopAndDelSketch(id) {
                commitProductPending = false;
                stopSketch();

                var sketchId = DataRecoverService.getSketchId();
                if (sketchId) {
                    DataRecoverService.deleteSketch('Product', sketchId);
                }

                // 这里必须是一开始获得的pid，不能是上一个promise返回的pid
                // 因为新增产品时保存pid是不存在的
                // 成功发布后会更新pid，如果用此时的pid 会导致不能成功删除之前保存的底稿
                if (!pid) {
                    // 清空本地所有新表单
                    DataRecoverService.delAllNewFormSketch('Product');
                }

                return {
                    bindId: id,
                    bindInfo: id
                };
            }

        }

        // 实训任务-产品发布 插入逻辑

        // 非直接下单品 directlyOrder=0
        function productTMInterpolator0(prodOption) {
            var TM = DSSX.TrainingMission;
            var type = TM.MissionType.Product_Publish;
            productTMInterpolator(prodOption, TM, type);
        }

        // 直接下单品 directlyOrder=1
        function productTMInterpolator1(prodOption) {
            var TM = DSSX.TrainingMission;
            var type = TM.MissionType.Product_Publish_DirectOrder;
            productTMInterpolator(prodOption, TM, type);
        }

        // 实训任务插入
        function productTMInterpolator(prodOption, TM, type) {
            var pid = prodOption.bindId;
            var bindInfo = prodOption.bindInfo;

            return TM.tryStart(type, {bindId: pid, bindInfo: bindInfo})
                .then(tryStartTMSuc, tryStartTMErr);

            function tryStartTMSuc(tmc) {

            }

            function tryStartTMErr(err) {
                console.log('[TM] tryStartTMErr', err);
            }
        }

        // 提交产品信息，创建或者更新产品
        function commitProduct2Service(form, option) {
            var url = '',
                pid = option.pid,
                _params = {
                    method: 'commit'
                },
                isFirstProduct = option.isFirstProduct
            ;

            // 根据语言市场判断调用的API接口
            if(form.langMarket == "EN") {
                if (pid) {
                    url = '/usr/api/updateProduct';
                    form.id = pid;
                } else {
                    url = '/usr/api/addProduct';
                }
            }
            else {
                if (pid) {
                    url = '/usr/api/updateMLProduct';
                    form.id = pid;
                } else {
                    url = '/usr/api/addMLProduct';
                }
            }
            isFirstProduct && (_params.isFirst = 'yes');
            option.taskId && (_params.taskId = option.taskId);

            return request.post(url, _params, form, true).then(function (res) {
                return res.data || {};
            }, function (err) {

                var code = util.safe(err, 'data.data.code', -1);

                if (code === 3) {
                    layer.msg('该产品已被删除，请勿重新提交！');
                    return $q.reject(err);
                }

                DSSX.dialog.err(err, {
                    moduleName: '产品编辑',
                    funcName: 'commitProduct2Service',
                    text: '更新产品信息失败'
                });
                console.log('[product-post] commitProduct2Service fail:', err);
                return $q.reject(err);
            });
        }

        // 改变国际站状态并绑定产品 id
        function changeAccountStateAndBindPid(option) {
            return request.get('/usr/api/updateAccountState?state=3', {pid: option.pid}, true)
                .then(function (res) {
                    // 国际站更改后的状态
                    option.latestState = util.safe(res, 'data.state', '');
                    return option;
                }, function (err) {
                    DSSX.dialog.err(err, {
                        moduleName: '产品编辑',
                        funcName: 'changeAccountStateAndBindPid',
                        text: '国际开通状态更改失败'
                    });
                    console.log('[product-post] changeAccountStateAndBindPid fail:', err);
                    return $q.reject(err);
                });
        }

        // 跳到首页
        function jumpToHomePage() {
            setTimeout(function () {
                window.location.href = "/";
            }, 400);
        }

        // 切换页面布局
        function switchPageLayout(type) {
            if (type === 'commitSuccess') {
                vm.onSubmit();
            }
        }

        // 保存产品信息
        function saveProductInfo() {

            if (commitProductPending) {
                layer.msg('已经在提交，请等待。。。');
                return;
            }

            commitProductPending = true;

            // 预览模式
            if (DSSX.attr.isPreviewMode) {
                DSSX.godMode.msg('预览模式只能查看，不能进行修改操作。');
                commitProductPending = false;
                return;
            }

            layer.closeAll();

            // 产品名称不能为空
            if (!vm.f.checkFormData.checkProductName()) {
                commitProductPending = false;
                return;
            }

            var form = handleFormData();

            var url = '',
                _params = {
                    method: 'save'
                },
                pid = util.queryString('productId');

            // 根据语言市场判断调用的API接口
            if(form.langMarket == "EN") {
                if (pid === '') {
                    url = '/usr/api/addProduct';
                } else {
                    url = '/usr/api/updateProduct';
                    form.id = pid;
                }
            }
            else {
                if (pid === '') {
                    url = '/usr/api/addMLProduct';
                } else {
                    url = '/usr/api/updateMLProduct';
                    form.id = pid;
                }
            }

            request.post(url, _params, form, true).then(function (res) {
                res = res || {};
                var data = res.data || {};
                if (!pid && data.productId) {
                    var href = util.updateUrlSearch(location.href, 'productId', data.productId);
                    history.replaceState(null, '', href);
                }

                stopSketch();
                // 更新底稿id为pid
                var sketchId = DataRecoverService.getSketchId();
                if (sketchId) {
                    DataRecoverService.updateSketch(null, data.productId);
                    DataRecoverService.deleteSketch('Product', sketchId);
                }

                if (!pid) {
                    // 清空本地所有新表单
                    DataRecoverService.delAllNewFormSketch('Product');
                }

                layer.alert('保存成功');
                console.log('save product success', data);
            }, function (err) {

                var code = util.safe(err, 'data.data.code', -1);

                if (code === 3) {
                    layer.msg('该产品已被删除，请勿再次保存！');
                    return;
                }
                
                DSSX.dialog.err(err, {
                    moduleName: '产品编辑',
                    funcName: 'saveProductInfo',
                    text: '保存草稿失败'
                });
            }).finally(function () {
                commitProductPending = false;
            });
        }

        //预览按钮的点击事件
        function previewInfo() {
            layer.closeAll();
            normalEdit = vm.getNormalEditContent();

            var productId = util.queryString('productId') || '';
            if (productId) {
                PREVIEW_KEY = productId;
            }

            window.localStorage[PREVIEW_KEY] = JSON.stringify(handleFormData());
            window.open("product-preview.html?productId=" + PREVIEW_KEY);
        }

        // 停止底稿功能
        function stopSketch() {
            var stop = DataRecoverService.getStopSaveFlag();

            if (stop.stopSaveLS) {
                $interval.cancel(stop.stopSaveLS);
            }

            if (stop.stopSaveServer) {
                $interval.cancel(stop.stopSaveServer);
            }
        }

        /******************计算信息填写完整度*****************/
        // 基本信息
        function countBasicInfoPer() {
            var per = 0;

            if (vm.d.form.productName) {
                per += 17;
            }

            var keys = vm.d.keywords;
            for (var i = 0; i < keys.length; i++) {
                if (keys[i].value) {
                    per += 17;
                    break;
                }
            }

            if (vm.d.form.group) {
                per += 17;
            }

            if (vm.d.form.model) {
                per += 17;
            }

            if (vm.d.form.brand) {
                per += 17;
            }

            if (vm.d.sourceAreaInfo.selected.value) {
                per += 17;
            }

            if (per >= 100) {
                per = 100;
            }

            vm.c.scoreList[0].score = per + '%';
            vm.c.scoreList[0].scoreNum = per;
            countTotalRateProgress();
        }

        // 产品详情
        function countDetailInfoPer() {

            var per = 0;

            if (vm.d.files.list.length > 0) {
                per += 50;
            }

            if (vm.d.editMode === 'normal') {

                // 第一次scopewatch vm.form 为null
                vm.form = vm.form || {};
                vm.form.normalEdit = vm.form.normalEdit || '';

                if (normalEdit.text.length > 0 || (vm.form && vm.form.normalEdit.length > 0)) {
                    per += 50;
                }
            } else {
                vm.form = vm.form || {};
                if (vm.form.detailDesc && vm.form.detailDesc.items && vm.form.detailDesc.preview) {
                    per += 50;
                }
            }

            vm.c.scoreList[1].score = per + '%';
            vm.c.scoreList[1].scoreNum = per;
            countTotalRateProgress();
        }

        // 交易信息
        function countTradeInfoPer() {
            var per = 0;

            if (vm.d.directOrder === 'yes') {
                vm.d.directOrderInfo.list.forEach(function (value) {
                    value.order && value.price && vm.d.directOrderUnitsInfo.selected
                    && vm.d.directOrderUnitsInfo.selected !== '计量单位'
                    && (vm.d.saleMethod === 'byPiece' || (vm.d.saleMethod === 'byBatch' && vm.d.directOrderInfo.batchUnit > 0))
                    && (per += 100);
                });
                per > 100 && (per = 100);
            } else {
                var payMethod = vm.d.payMethod;
                for (var attr in payMethod) {
                    if (payMethod[attr].selected && payMethod[attr].value) {
                        per += 50;
                        break;
                    }
                }
                if (vm.d.tradeMode === 'ladder') {
                    var list = vm.d.tradeLadderInfo.list;

                    for (var i = 0; i < list.length; i++) {
                        if (list[i].order && list[i].price && vm.d.tradeLadderMeasureUnitsInfo.selected && vm.d.tradeLadderMeasureUnitsInfo.selected !== '计量单位') {
                            per += 50;
                            break;
                        }
                    }
                } else {
                    var tradeSingleInfo = vm.d.tradeSingleInfo;
                    if (tradeSingleInfo.priceMin.value
                        && tradeSingleInfo.priceMax.value
                        && tradeSingleInfo.orderMin.value
                        && vm.d.currencyInfo.selected
                        && vm.d.currencyInfo.selected !== '货币种类'
                        && vm.d.tradeSingleMeasureUnitsInfo.selected
                        && vm.d.tradeSingleMeasureUnitsInfo.selected !== '计量单位'
                    ) {
                        per += 50;
                    }
                }
            }

            vm.c.scoreList[2].score = per + '%';
            vm.c.scoreList[2].scoreNum = per;
            countTotalRateProgress();
        }

        // 物流信息
        function countPackageInfoPer() {

            var per = 0;

            // if (vm.d.form.deliveryTime) {
            //     per += 25;
            // }

            if(vm.d.directOrder === 'yes') {
                // 直接下单品
                var sizePerProduct = vm.d.form.logisticsInfo.sizePerProduct
                if(sizePerProduct.length.value && sizePerProduct.width.value && sizePerProduct.height.value) {
                    per += 25;
                }

                if(vm.d.form.logisticsInfo.grossWeightPerProduct) {
                    per += 25;
                }

                if (vm.d.deliveryDateInfo.list.length && vm.d.deliveryDateInfo.list[0].num !== '' && vm.d.deliveryDateInfo.list[0].day !== '') {
                    per += 25;
                }

                if (vm.d.form.packing) {
                    per += 25;
                }
            } else {
                // 非直接下单品
                if (vm.d.deliveryDateInfo.list.length && vm.d.deliveryDateInfo.list[0].num !== '' && vm.d.deliveryDateInfo.list[0].day !== '') {
                    per += 25;
                }

                if (vm.d.form.harbor) {
                    per += 25;
                }

                if (vm.d.form.packing) {
                    per += 25;
                }

                if (vm.d.supplyInfo.number
                    && vm.d.packageMeasureUnitsInfo.selected !== '计量单位'
                    && vm.d.timeUnitsInfo.selected !== '时间单位') {
                    per += 25;
                }
            }

            // if (vm.packageImage.list.length) {
            //     per += 20;
            // }

            vm.c.scoreList[3].score = per + '%';
            vm.c.scoreList[3].scoreNum = per;
            countTotalRateProgress();
        }

        function onContentChange(e) {
            normalEdit = e.content;
            vm.form && (vm.form.normalEdit = e.content);
            countDetailInfoPer();
        }

        function countTotalRateProgress() {
            var list = vm.c.scoreList;
            var score = 0;
            for (var i = 0; i < list.length; i++) {
                if (i === 0) {
                    score += (list[i].scoreNum) * 0.34;
                } else {
                    score += (list[i].scoreNum) * 0.22;
                }

            }

            vm.c.totalRateProgress = score.toFixed(2);
        }

        function gotoProductInfo(index) {

            var h1 = $('.' + vm.c.scoreList[index].class).eq(0).offset().top - 66;
            $('html,body').animate({'scrollTop': h1}, 0);

            setProductInfoPerStatus(index);
        }

        function gotoProductInfoDetail(detailName) {
            var h1 = $('.' + detailName).eq(0).offset().top - 66;
            $('html,body').animate({'scrollTop': h1}, 0);
        }

        function setProductInfoPerStatus(index) {
            for (var i = 0; i < vm.c.scoreList.length; i++) {
                vm.c.scoreList[i].selected = false;
            }
            vm.c.scoreList[index].selected = true;
        }

        function initScrollEvent() {
            // 滚动条事件
            $(document).scroll(function () {
                var scrollTop = $(document).scrollTop() + 80;

                vm.d.showGotoTopBtn = scrollTop > basicInfoDom.eq(0).offset().top;

                if (scrollTop < detailInfoDom.eq(0).offset().top) {
                    setProductInfoPerStatus(0);
                }

                if (scrollTop > detailInfoDom.eq(0).offset().top && scrollTop < tradeInfoDom.eq(0).offset().top) {
                    setProductInfoPerStatus(1);
                }

                if (scrollTop > tradeInfoDom.eq(0).offset().top && scrollTop < packageInfoDom.eq(0).offset().top) {
                    setProductInfoPerStatus(2);
                }

                if (scrollTop > packageInfoDom.eq(0).offset().top && scrollTop < specialServiceDom.eq(0).offset().top) {
                    setProductInfoPerStatus(3);
                }

                if (scrollTop > specialServiceDom.eq(0).offset().top) {
                    setProductInfoPerStatus(4);
                }
            });
        }

        function initScopeWatch() {

            $scope.$watch('vm.d.files.list.length', function (nv, ov) {
                countDetailInfoPer();
            });

            $scope.$watch('vm.d.tradeLadderMeasureUnitsInfo.selected', function (nv, ov) {
                countTradeInfoPer();
                checkFobLadderUnit();
            });

            $scope.$watch('vm.d.currencyInfo.selected', function (nv, ov) {
                countTradeInfoPer();
                checkFobSingleUnit('currency');
            });

            $scope.$watch('vm.d.tradeSingleMeasureUnitsInfo.selected', function (nv, ov) {
                countTradeInfoPer();
                checkFobSingleUnit('measure');
            });

        }

        function gotoTop() {
            $('html, body').animate({'scrollTop': 0}, 500);
        }

        function onResize() {

        }

        function showProvince() {
            var value = vm.d.sourceAreaInfo.selected.value;
            var provinceMap = constantStore.PROVINCE_MAP[value];

            if (provinceMap) {
                vm.d.provinceInfo.list = provinceMap;
                vm.d.provinceInfo.selected = provinceMap[0];
            } else {
                vm.d.provinceInfo.list = [];
                vm.d.provinceInfo.selected = null;
            }

            countBasicInfoPer();
        }

        // 智能编辑 普通编辑切换提示
        function toggleEditorMode(mode) {
            if (vm.d.editMode === 'normal' && mode === 'smart') {
                // 判断普通编辑是否有内容
                var normalEditorContent = vm.getNormalEditContent();
                if (normalEditorContent.remainImgCount !== 15 || normalEditorContent.remainWordCount !== 20000) {
                    var layerIndex = layer.confirm('切换至“智能编辑”，保存提交后将会丢失“普通编辑”中的内容', {
                        btn: ['切换', '不切换']
                    }, function () {
                        toggle(mode, layerIndex);
                    }, function () {
                    });
                } else {
                    toggle(mode);
                }
            }

            if (vm.d.editMode === 'smart' && mode === 'normal') {
                // 判断智能编辑是否有内容
                if (editorInfo.preview || (editorInfo.items && editorInfo.items.length)) {
                    var layerIndex2 = layer.confirm('切换至“普通编辑”，保存提交后将会丢失“智能编辑”中的内容', {
                        btn: ['切换', '不切换']
                    }, function () {
                        toggle(mode, layerIndex2);
                    }, function () {
                    });
                } else {
                    toggle(mode);
                }
            }

            function toggle(mode, index) {
                vm.d.editMode = mode;
                if (!isNaN(index)) {
                    countDetailInfoPer();
                    layer.close(index);
                }
            }
        }

        /**
         * 判断是否是空对象
         * @param e
         * @returns {boolean}
         */
        function isEmptyObject(e) {
            for (var t in e)
                return !1;
            return !0
        }

        /**
         * 切换添加出口信息
         * @param arg_isNext boolean
         */
        function changeExportInfoView(arg_isNext) {
            if (arg_isNext) {
                var formIsPass = globalCheckForm();
                if (!formIsPass) {
                    $timeout(function () {
                        gotoErrorMsg();
                    });
                    return;
                }

                vm.c.showExportInfo = true;
                event.emit('product-post-change-export-view', {
                    showExportView: true
                });
            } else {
                vm.c.showExportInfo = false;
                event.emit('product-post-change-export-view', {
                    showExportView: false
                });
            }
        }

        vm.packageImage = {
            list: [],
            uploading: false,
            remove: function (arg_index) {
                arg_index in vm.packageImage.list && vm.packageImage.list.splice(arg_index, 1);
            },
            removeAll: function () {
                if (vm.packageImage.uploading) {
                    return;
                }
                vm.packageImage.list = [];
            },
            upload: function (event) {
                if (vm.packageImage.uploading) {
                    DSSX.dialog.msg('图片正在上传中');
                    return;
                }

                var list = vm.packageImage.list;
                var SIZE_LIMIT = 2 * 1024 * 1024;
                var TYPE_LIMIT = {
                    'image/jpeg': true,
                    'image/png': true
                };

                if (list.length >= 2) {
                    DSSX.dialog.msg('最多允许上传2个图片');
                    return;
                }

                var file = event.files[0];
                if (!file || file.size === 0) {
                    DSSX.dialog.msg('图片不能为空');
                    return;
                }
                if (file.size > SIZE_LIMIT) {
                    DSSX.dialog.msg('附件大小超出限制');
                    return;
                }
                if (!TYPE_LIMIT[file.type]) {
                    DSSX.dialog.msg('不支持的文件类型');
                    return;
                }

                vm.packageImage.uploading = true;
                var fileInfo = {
                    url: '',
                    name: file.name,
                    progress: {
                        totalSize: file.size,
                        loadedSize: 0,
                        show: false
                    }
                };

                list.push(fileInfo);
                UploaderService.start(file, fileInfo, function (arg) {
                    var id = '#package-image-' + (list.length - 1),
                        loadedSize = arg.progress.loadedSize,
                        totalSize = arg.progress.totalSize,
                        progressPercent = Math.round(loadedSize * 100 / totalSize);

                    $(id).val(progressPercent);
                }, {
                    max: 1
                }).then(function (res) {
                    var url = res.data || '';
                    list[list.length - 1].url = url.slice(url.indexOf('/'));
                }, function (err) {
                    DSSX.dialog.err(err, {
                        moduleName: 'product-form.js',
                        funcName: 'packageImage.uploader',
                        text: '文件上传失败'
                    });
                }).finally(function () {
                    vm.packageImage.uploading = false;
                    $('#package-image-upload').val(null);
                });
            },
            initPhotoBank: function () {
                var openBtn = $('.photo-bank-show-btn-package-image');
                openBtn.click(openPhotoBankPopSelect);

                function openPhotoBankPopSelect() {
                    window.photoBankSelectCallBack = photoBankSelectCallBack;
                    var count = getSelectedPhotoCount();
                    if (count >= 2) {
                        layer.alert("最多允许上传2个图片");
                        return;
                    }

                    layer.open({
                        type: 2,
                        title: 0,
                        closeBtn: 0,
                        area: ["982px", "642px"],
                        content: ['iframe/photo-bank/pop-select.html', 'no'],
                        success: openSuccess
                    });

                    function openSuccess(layero, index) {
                        var iframeWin = window[layero.find('iframe')[0]['name']];

                        iframeWin.dataTransfer && iframeWin.dataTransfer('imgMax', 2 - count);
                    }
                }

                function photoBankSelectCallBack(data) {
                    console.log('photoBankSelectCallBack[packageImage]', data);
                    var list = [];
                    for (var i = 0; i < data.length; i++) {
                        var pic = {
                            url: data[i].img,
                            name: data[i].name
                        };

                        list.push(pic);
                    }

                    $timeout(function () {
                        vm.packageImage.list = vm.packageImage.list.concat(list);
                        window.photoBankSelectCallBack = null;
                    });
                }

                function getSelectedPhotoCount() {
                    return vm.packageImage.list.length;
                }
            },
            init: function () {
                vm.packageImage.initPhotoBank();
            }
        };

        // 根据错误列表高度确定是否展示产品质量检测窗口
        function showPostPanel() {
            return $(".form-error-tips:eq(1) ul").height() === 0;
        }

        // 初始化运费模板
        function initShipTemplates() {
            var url = '/usr/api/getShippingTemplateList'; 
            request.post(url, {}, {}, true).then(callback, errCallback);

            function callback(res) {
                // 找不到运费模板
                if(!res.data.result) {
                    checkFormData.checkShipTemplate();
                    return;
                }

                var info = vm.d.shipTemplatesInfo;

                info.list = [];
                for(var i in res.data.result) {
                    // 如果运费模板中包含阿里物流的承运商，类型就是0，否则为1
                    var shipTemplate = res.data.result[i];
                    var type = 1;

                    // 快递
                    if (shipTemplate.expressTemplate && shipTemplate.expressTemplate.some(function(item) {
                        return item.logisticsType == '阿里物流';
                     })) {
                        type = 0;
                    }

                    // 海运
                    if (shipTemplate.seaFreightTemplate && shipTemplate.seaFreightTemplate.some(function(item) {
                        return item.logisticsType == '阿里物流';
                     })) {
                        type = 0;
                    }

                    // 铁路
                    if (shipTemplate.railwayTemplate && shipTemplate.railwayTemplate.some(function(item) {
                        return item.logisticsType == '阿里物流';
                     })) {
                        type = 0;
                    }

                    var item = {
                        label: shipTemplate.templateName,
                        value: shipTemplate.id,
                        type: type,
                    }
                    info.list.push(item);
                }

                // 默认选中第一个模板
                info.selected = info.list[0];
                vm.d.form.logisticsInfo.feightTmpl.id = info.selected.value;
                vm.d.form.logisticsInfo.isRts = info.selected.type === 0 ? 'yes': 'no';
            }

            function errCallback(err) {
                DSSX.dialog.err(err, {
                    moduleName: 'product-form.js',
                    funcName: 'initShipTemplates',
                    text: '初始化运费模板失败'
                });
            }
        }

        // 修改运费模板
        function changeShipTemplate() {
            vm.d.form.logisticsInfo.feightTmpl.id = vm.d.shipTemplatesInfo.selected.value;
            vm.d.form.logisticsInfo.isRts = vm.d.shipTemplatesInfo.selected.type === 0 ? 'yes': 'no';
        }
    }

})();
